if (window.addEventListener && typeof mmLoaded == "undefined") {
    var mmThemeFixesBeforeInit = function() {
        /* generic mobile menu toggle translate effect */
        document.addEventListener("toggleSubmenu", function(e) {
            var pc = document.querySelector("#PageContainer");
            var mm = document.querySelector("#MobileNav");
            if (pc && mm && typeof e.mmMobileHeight != "undefined") {
                var pcStyle = pc.getAttribute("style");
                if (pcStyle && pcStyle.indexOf("translate3d") != -1) {
                    pc.style.transform = "translate3d(0px, " + e.mmMobileHeight + "px, 0px)";
                }
            }
        });
        jQueryBuddha(window).on("load", function() {
            setTimeout(function() {
                if (jQueryBuddha("#megamenu_level__1").length > 0 && jQueryBuddha("#megamenu_level__1").is(".vertical-mega-menu")) {
                    reinitMenus("#megamenu_level__1");
                }
            }, 100);
        });
    };
    var mmThemeFixesBefore = function() {
        window.buddhaFilterLiElements = function(liElements) {
            var elements = [];
            liElements.each(function() {
                if (jQueryBuddha(this).find("[href=\"/cart\"]").length == 0) elements.push(jQueryBuddha(this));
            });
            return elements;
        };
        if (tempMenuObject.ul.is("#mobile_menu, #velaMegamenu .nav, #SiteNav, #siteNav")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children().not(".search_container,.site-nav__item_cart"));
        } else if (tempMenuObject.ul.is(".main_nav .nav .menu")) {
            var numMenusApplied = 0,
                numMenusAppliedSticky = 0;
            jQueryBuddha(".main_nav .nav .menu").each(function() {
                if (jQueryBuddha(this).parents(".sticky_nav").length == 0) {
                    if (jQueryBuddha(this).find(".buddha-menu-item").length > 0) {
                        numMenusApplied++;
                    }
                } else {
                    if (jQueryBuddha(this).find(".buddha-menu-item").length > 0) {
                        numMenusAppliedSticky++;
                    }
                }
            });
            if (((tempMenuObject.ul.parents(".sticky_nav").length > 0) && (numMenusAppliedSticky < 1)) || ((tempMenuObject.ul.parents(".sticky_nav").length == 0) && (numMenusApplied < 1))) {
                tempMenuObject.forceMenu = true;
                tempMenuObject.skipCheck = true;
                tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children().not(".search_container,.site-nav__item_cart"));
            }
        } else if (tempMenuObject.ul.is("#mobile-menu:not(.mm-menu)") && tempMenuObject.ul.find(".hamburger,.shifter-handle").length == 0) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
        } else if (tempMenuObject.ul.is("#accessibleNav") && tempMenuObject.ul.parents("#topnav2").length == 0) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children().not(".customer-navlink"));
        } else if (tempMenuObject.ul.is("#megamenu_level__1")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "level_1__item";
            tempMenuObject.aClasses = "level_1__link";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
        } else if (tempMenuObject.ul.is(".mobile-nav__items")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "mobile-nav__item";
            tempMenuObject.aClasses = "mobile-nav__link";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
        } else if (tempMenuObject.ul.is("#NavDrawer > .mobile-nav")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "mobile-nav__item";
            tempMenuObject.aClasses = "mobile-nav__link";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children().not(".mobile-nav__search"));
        } else if (tempMenuObject.ul.is(".mobile-nav-wrapper > .mobile-nav")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "mobile-nav__item border-bottom";
            tempMenuObject.aClasses = "mobile-nav__link";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children().not(".mobile-nav__search"));
        } else if (tempMenuObject.ul.is("#nav .mm-panel .mm-listview")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
            var firstMmPanel = true;
            jQueryBuddha("#nav>.mm-panels>.mm-panel").each(function() {
                if (firstMmPanel) {
                    firstMmPanel = false;
                    jQueryBuddha(this).removeClass("mm-hidden mm-subopened");
                } else {
                    jQueryBuddha(this).remove();
                }
            });
        } else if (tempMenuObject.ul.is(".SidebarMenu__Nav--primary")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "Collapsible";
            tempMenuObject.aClasses = "Collapsible__Button Heading u-h6";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
        } else if (tempMenuObject.u.matches(".mm_menus_ul")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "ets_menu_item";
            tempMenuObject.aClasses = "mm-nowrap";
            tempMenuObject.liItems = buddhaFilterLiElements(jQueryBuddha(tempMenuObject.ul).children());
            mmAddStyle(" .horizontal-mega-menu > .buddha-menu-item > a {white-space: nowrap;} ", "mmThemeCStyle");
        } else if (tempMenuObject.u.matches("#accordion")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "";
            tempMenuObject.aClasses = "";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } else if (tempMenuObject.u.matches(".mobile-menu__panel:first-child .mobile-menu__nav")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "mobile-menu__nav-item";
            tempMenuObject.aClasses = "mobile-menu__nav-link";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } else if (tempMenuObject.u.matches("#nt_menu_id")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "menu-item type_simple";
            tempMenuObject.aClasses = "lh__1 flex al_center pr";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } else if (tempMenuObject.u.matches("#menu_mb_cat")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "menu-item type_simple";
            tempMenuObject.aClasses = "";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } else if (tempMenuObject.u.matches("#menu_mb_ul")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "menu-item only_icon_false";
            tempMenuObject.aClasses = "";
            tempMenuObject.liItems = mmNot(tempMenuObject.u.children, "#customer_login_link,#customer_register_link,#item_mb_help", true);
            mmAddStyle(" #menu_mb_ul.vertical-mega-menu li.buddha-menu-item>a {display: flex !important;} #menu_mb_ul.vertical-mega-menu li.buddha-menu-item>a>.mm-title {padding: 0 !important;} ", "mmThemeStyle");
        } else if (tempMenuObject.u.matches(".header__inline-menu > .list-menu")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "";
            tempMenuObject.aClasses = "header__menu-item list-menu__item link focus-inset";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } else if (tempMenuObject.u.matches(".menu-drawer__navigation>.list-menu")) {
            tempMenuObject.forceMenu = true;
            tempMenuObject.skipCheck = true;
            tempMenuObject.liClasses = "";
            tempMenuObject.aClasses = "menu-drawer__menu-item list-menu__item link link--text focus-inset";
            tempMenuObject.liItems = tempMenuObject.u.children;
        } /* try to find li and a classes for requested menu if they are not set */
        if (tempMenuObject.skipCheck == true) {
            var _links = [];
            jQueryBuddha.each(linkLists, function(key, item) {
                if (selectedMenu == key) {
                    _links = item.items;
                    return false;
                }
            });
            jQueryBuddha(this).children("li").each(function() {
                var li = jQueryBuddha(this);
                var a = li.find("a").first();
                var href = a.attr("href");
                if ((href == undefined || (href != undefined && (href.substr(0, 1) == "#" || href == ""))) && li.find("a:nth-child(2)").length > 0) {
                    a = li.find("a:nth-child(2)");
                    href = a.attr("href");
                } else if ((href == undefined || (href != undefined && (href.substr(0, 1) == "#" || href == ""))) && li.find("a>a").length > 0) {
                    a = li.find("a>a");
                    href = a.attr("href");
                }
                if (_links[tempMenuObject.elementFits] != undefined && href == _links[tempMenuObject.elementFits]) {
                    if (tempMenuObject.liClasses == undefined) {
                        tempMenuObject.liClasses = "";
                    }
                    tempMenuObject.liClasses = concatClasses(li.attr("class"), tempMenuObject.liClasses);
                    if (tempMenuObject.aClasses == undefined) {
                        tempMenuObject.aClasses = [];
                    }
                    tempMenuObject.aClasses = concatClasses(a.attr("class"), tempMenuObject.aClasses);
                    tempMenuObject.elementFits++;
                } else if (tempMenuObject.elementFits > 0 && tempMenuObject.elementFits != _links.length) {
                    tempMenuObject.elementFits = 0;
                    if (href == _links[0]) {
                        tempMenuObject.elementFits = 1;
                    }
                }
            });
        }
    };
    var schemaDesignJSON = [{
            "action": "menu-select",
            "value": "main-menu"
        }, {
            "action": "design",
            "setting": "addtocart_background_hover_color",
            "value": "#fb3f78"
        }, {
            "action": "design",
            "setting": "price_color",
            "value": "#000000"
        }, {
            "action": "design",
            "setting": "link_hover_color",
            "value": "#fb3f78"
        }, {
            "action": "design",
            "setting": "font_family",
            "value": "Default"
        }, {
            "action": "design",
            "setting": "button_background_hover_color",
            "value": "#0d8781"
        }, {
            "action": "design",
            "setting": "button_background_color",
            "value": "#0da19a"
        }, {
            "action": "design",
            "setting": "background_hover_color",
            "value": "#f9f9f9"
        }, {
            "action": "design",
            "setting": "background_color",
            "value": "#ffffff"
        }, {
            "action": "design",
            "setting": "button_text_hover_color",
            "value": "#ffffff"
        }, {
            "action": "design",
            "setting": "button_text_color",
            "value": "#ffffff"
        }, {
            "action": "design",
            "setting": "text_color",
            "value": "#222222"
        }, {
            "action": "design",
            "setting": "vertical_text_color",
            "value": "#ffffff"
        }, {
            "action": "design",
            "setting": "vertical_link_hover_color",
            "value": "#0da19a"
        }, {
            "action": "design",
            "setting": "vertical_font_size",
            "value": "13px"
        }, {
            "action": "design",
            "setting": "font_size",
            "value": "15px"
        }],
        mmDomChangeSkipUl = "",
        buddhaMegaMenuShop = "selectedliving-de.myshopify.com",
        mmjQueryFile = "https://code.jquery.com/jquery-3.5.1.slim.min.js";
    ! function(t, e) {
        var n = function(t, e, n) {
            "use strict";
            var a, i;
            if (function() {
                    i = {
                        lazyClass: "mmLazyload",
                        loadedClass: "mmLazyloaded",
                        loadingClass: "mmLazyloading",
                        preloadClass: "mmLazypreload",
                        errorClass: "mmLazyerror",
                        autosizesClass: "mmLazyautosizes",
                        fastLoadedClass: "mmLs-is-cached",
                        iframeLoadMode: 0,
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: .8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 0,
                        throttleDelay: 125
                    }
                }(), !e || !e.getElementsByClassName) return {
                init: function() {},
                cfg: i,
                noSupport: !0
            };
            var r = e.documentElement,
                o = t.HTMLPictureElement,
                s = t.addEventListener.bind(t),
                l = t.setTimeout,
                d = t.requestAnimationFrame || l,
                u = t.requestIdleCallback,
                c = /^picture$/i,
                f = ["load", "error", "lazyincluded", "_lazyloaded"],
                m = {},
                g = Array.prototype.forEach,
                v = function(t, e) {
                    return m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), m[e].test(t.getAttribute("class") || "") && m[e]
                },
                h = function(t, e) {
                    v(t, e) || t.setAttribute("class", (t.getAttribute("class") || "").trim() + " " + e)
                },
                y = function(t, e) {
                    var n;
                    (n = v(t, e)) && t.setAttribute("class", (t.getAttribute("class") || "").replace(n, " "))
                },
                z = function(t, e, n) {
                    var a = n ? "addEventListener" : "removeEventListener";
                    n && z(t, e), f.forEach(function(n) {
                        t[a](n, e)
                    })
                },
                p = function(t, n, i, r, o) {
                    var s = e.createEvent("Event");
                    return i || (i = {}), i.instance = a, s.initEvent(n, !r, !o), s.detail = i, t.dispatchEvent(s), s
                },
                b = function(e, n) {
                    var a;
                    !o && (a = t.picturefill || i.pf) ? (n && n.src && !e.getAttribute("srcset") && e.setAttribute("srcset", n.src), a({
                        reevaluate: !0,
                        elements: [e]
                    })) : n && n.src && (e.src = n.src)
                },
                A = function(t, e) {
                    return (getComputedStyle(t, null) || {})[e]
                },
                C = function(t, e, n) {
                    for (n = n || t.offsetWidth; n < i.minSize && e && !t._lazysizesWidth;) n = e.offsetWidth, e = e.parentNode;
                    return n
                },
                E = function() {
                    var t, n, a = [],
                        i = [],
                        r = a,
                        o = function() {
                            var e = r;
                            for (r = a.length ? i : a, t = !0, n = !1; e.length;) e.shift()();
                            t = !1
                        },
                        s = function(a, i) {
                            t && !i ? a.apply(this, arguments) : (r.push(a), n || (n = !0, (e.hidden ? l : d)(o)))
                        };
                    return s._lsFlush = o, s
                }(),
                L = function(t, e) {
                    return e ? function() {
                        E(t)
                    } : function() {
                        var e = this,
                            n = arguments;
                        E(function() {
                            t.apply(e, n)
                        })
                    }
                },
                _ = function(t) {
                    var e, a = 0,
                        r = i.throttleDelay,
                        o = i.ricTimeout,
                        s = function() {
                            e = !1, a = n.now(), t()
                        },
                        d = u && o > 49 ? function() {
                            u(s, {
                                timeout: o
                            }), o !== i.ricTimeout && (o = i.ricTimeout)
                        } : L(function() {
                            l(s)
                        }, !0);
                    return function(t) {
                        var i;
                        (t = !0 === t) && (o = 33), e || (e = !0, i = r - (n.now() - a), i < 0 && (i = 0), t || i < 9 ? d() : l(d, i))
                    }
                },
                w = function(t) {
                    var e, a, i = function() {
                            e = null, t()
                        },
                        r = function() {
                            var t = n.now() - a;
                            t < 99 ? l(r, 99 - t) : (u || i)(i)
                        };
                    return function() {
                        a = n.now(), e || (e = l(r, 99))
                    }
                },
                M = function() {
                    var o, u, f, m, C, M, x, W, B, S, T, F, R = /^img$/i,
                        D = /^iframe$/i,
                        k = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
                        H = 0,
                        O = 0,
                        P = -1,
                        $ = function(t) {
                            O--, (!t || O < 0 || !t.target) && (O = 0)
                        },
                        q = function(t) {
                            return null == F && (F = "hidden" == A(e.body, "visibility")), F || !("hidden" == A(t.parentNode, "visibility") && "hidden" == A(t, "visibility"))
                        },
                        I = function(t, n) {
                            var a, i = t,
                                o = q(t);
                            for (W -= n, T += n, B -= n, S += n; o && (i = i.offsetParent) && i != e.body && i != r;)(o = (A(i, "opacity") || 1) > 0) && "visible" != A(i, "overflow") && (a = i.getBoundingClientRect(), o = S > a.left && B < a.right && T > a.top - 1 && W < a.bottom + 1);
                            return o
                        },
                        U = function() {
                            var t, n, s, l, d, c, f, g, v, h, y, z, p = a.elements;
                            if ((m = i.loadMode) && O < 8 && (t = p.length)) {
                                for (n = 0, P++; n < t; n++)
                                    if (p[n] && !p[n]._lazyRace)
                                        if (!k || a.prematureUnveil && a.prematureUnveil(p[n])) Y(p[n]);
                                        else if ((g = p[n].getAttribute("data-expand")) && (c = 1 * g) || (c = H), h || (h = !i.expand || i.expand < 1 ? r.clientHeight > 500 && r.clientWidth > 500 ? 500 : 370 : i.expand, a._defEx = h, y = h * i.expFactor, z = i.hFac, F = null, H < y && O < 1 && P > 2 && m > 2 && !e.hidden ? (H = y, P = 0) : H = m > 1 && P > 1 && O < 6 ? h : 0), v !== c && (M = innerWidth + c * z, x = innerHeight + c, f = -1 * c, v = c), s = p[n].getBoundingClientRect(), (T = s.bottom) >= f && (W = s.top) <= x && (S = s.right) >= f * z && (B = s.left) <= M && (T || S || B || W) && (i.loadHidden || q(p[n])) && (u && O < 3 && !g && (m < 3 || P < 4) || I(p[n], c))) {
                                    if (Y(p[n]), d = !0, O > 9) break
                                } else !d && u && !l && O < 4 && P < 4 && m > 2 && (o[0] || i.preloadAfterLoad) && (o[0] || !g && (T || S || B || W || "auto" != p[n].getAttribute(i.sizesAttr))) && (l = o[0] || p[n]);
                                l && !d && Y(l)
                            }
                        },
                        j = _(U),
                        G = function(t) {
                            var e = t.target;
                            if (e._lazyCache) return void delete e._lazyCache;
                            $(t), h(e, i.loadedClass), y(e, i.loadingClass), z(e, K), p(e, "lazyloaded")
                        },
                        J = L(G),
                        K = function(t) {
                            J({
                                target: t.target
                            })
                        },
                        Q = function(t, e) {
                            var n = t.getAttribute("data-load-mode") || i.iframeLoadMode;
                            0 == n ? t.contentWindow.location.replace(e) : 1 == n && (t.src = e)
                        },
                        V = function(t) {
                            var e, n = t.getAttribute(i.srcsetAttr);
                            (e = i.customMedia[t.getAttribute("data-media") || t.getAttribute("media")]) && t.setAttribute("media", e), n && t.setAttribute("srcset", n)
                        },
                        X = L(function(t, e, n, a, r) {
                            var o, s, d, u, m, v;
                            (m = p(t, "lazybeforeunveil", e)).defaultPrevented || (a && (n ? h(t, i.autosizesClass) : t.setAttribute("sizes", a)), s = t.getAttribute(i.srcsetAttr), o = t.getAttribute(i.srcAttr), r && (d = t.parentNode, u = d && c.test(d.nodeName || "")), v = e.firesLoad || "src" in t && (s || o || u), m = {
                                target: t
                            }, h(t, i.loadingClass), v && (clearTimeout(f), f = l($, 2500), z(t, K, !0)), u && g.call(d.getElementsByTagName("source"), V), s ? t.setAttribute("srcset", s) : o && !u && (D.test(t.nodeName) ? Q(t, o) : t.src = o), r && (s || u) && b(t, {
                                src: o
                            })), t._lazyRace && delete t._lazyRace, y(t, i.lazyClass), E(function() {
                                var e = t.complete && t.naturalWidth > 1;
                                v && !e || (e && h(t, i.fastLoadedClass), G(m), t._lazyCache = !0, l(function() {
                                    "_lazyCache" in t && delete t._lazyCache
                                }, 9)), "lazy" == t.loading && O--
                            }, !0)
                        }),
                        Y = function(t) {
                            if (!t._lazyRace) {
                                var e, n = R.test(t.nodeName),
                                    a = n && (t.getAttribute(i.sizesAttr) || t.getAttribute("sizes")),
                                    r = "auto" == a;
                                (!r && u || !n || !t.getAttribute("src") && !t.srcset || t.complete || v(t, i.errorClass) || !v(t, i.lazyClass)) && (e = p(t, "lazyunveilread").detail, r && N.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, O++, X(t, e, r, a, n))
                            }
                        },
                        Z = w(function() {
                            i.loadMode = 3, j()
                        }),
                        tt = function() {
                            3 == i.loadMode && (i.loadMode = 2), Z()
                        },
                        et = function() {
                            if (!u) {
                                if (n.now() - C < 999) return void l(et, 999);
                                u = !0, i.loadMode = 3, j(), s("scroll", tt, !0)
                            }
                        };
                    return {
                        _: function() {
                            C = n.now(), a.elements = e.getElementsByClassName(i.lazyClass), o = e.getElementsByClassName(i.lazyClass + " " + i.preloadClass), s("scroll", j, !0), s("resize", j, !0), s("pageshow", function(t) {
                                if (t.persisted) {
                                    var n = e.querySelectorAll("." + i.loadingClass);
                                    n.length && n.forEach && d(function() {
                                        n.forEach(function(t) {
                                            t.complete && Y(t)
                                        })
                                    })
                                }
                            }), t.MutationObserver ? new MutationObserver(j).observe(r, {
                                childList: !0,
                                subtree: !0,
                                attributes: !0
                            }) : (r.addEventListener("DOMNodeInserted", j, !0), r.addEventListener("DOMAttrModified", j, !0), setInterval(j, 999)), s("hashchange", j, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(t) {
                                e.addEventListener(t, j, !0)
                            }), /d$|^c/.test(e.readyState) ? et() : (s("load", et), e.addEventListener("DOMContentLoaded", j), l(et, 2e4)), a.elements.length ? (U(), E._lsFlush()) : j()
                        },
                        checkElems: j,
                        unveil: Y,
                        _aLSL: tt
                    }
                }(),
                N = function() {
                    var t, n = L(function(t, e, n, a) {
                            var i, r, o;
                            if (t._lazysizesWidth = a, a += "px", t.setAttribute("sizes", a), c.test(e.nodeName || ""))
                                for (i = e.getElementsByTagName("source"), r = 0, o = i.length; r < o; r++) i[r].setAttribute("sizes", a);
                            n.detail.dataAttr || b(t, n.detail)
                        }),
                        a = function(t, e, a) {
                            var i, r = t.parentNode;
                            r && (a = C(t, r, a), i = p(t, "lazybeforesizes", {
                                width: a,
                                dataAttr: !!e
                            }), i.defaultPrevented || (a = i.detail.width) && a !== t._lazysizesWidth && n(t, r, i, a))
                        },
                        r = function() {
                            var e, n = t.length;
                            if (n)
                                for (e = 0; e < n; e++) a(t[e])
                        },
                        o = w(r);
                    return {
                        _: function() {
                            t = e.getElementsByClassName(i.autosizesClass), s("resize", o)
                        },
                        checkElems: o,
                        updateElem: a
                    }
                }(),
                x = function() {
                    !x.i && e.getElementsByClassName && (x.i = !0, N._(), M._())
                };
            return l(function() {
                i.init && x()
            }), a = {
                cfg: i,
                autoSizer: N,
                loader: M,
                init: x,
                uP: b,
                aC: h,
                rC: y,
                hC: v,
                fire: p,
                gW: C,
                rAF: E
            }
        }(t, t.document, Date);
        t.lazySizesBuddha = n, "object" == typeof module && module.exports && (module.exports = n)
    }("undefined" != typeof window ? window : {});
    var newMenu = !1,
        jQueryBuddha, mmLoaded = !0,
        mmLivIconsLoaded = !1,
        undo = [],
        redo = [],
        action = "",
        tempMenuObject = {},
        changedMenu = !1,
        submenuToggled = !1,
        changingPage = !1,
        saving = !1,
        panelOpened = !1,
        verticalMenuMaxWidth = 1e4,
        selectedMenu, clicked, touched, burgerIcon, disableOnClick = !1,
        globalTouch = !0,
        onClickOnlyReinit = !1,
        disableOnScroll = !1,
        mobileMenuMilliseconds = 350,
        ulPaths = [],
        submenuSizes = {},
        submenuDirections = {},
        submenuColumns = {},
        customHeaderOffset = !1,
        fontSize = 0,
        storeUlCount = 0,
        storeNavCount = 0,
        loadMegaMenuTries = 100,
        customMenuUls, defaultFontSelected = !1,
        forceMobile = !1,
        previewPanelLoaded = !1,
        allowMainMenuRecalibration = !0,
        readyStateCheckInterval, disableThemeScript = !1,
        mmApplyOnce = !1,
        initializedSchema = !1,
        mmSetSmBoundriesOnReinit = !1,
        mmHorizontalMenus = !1,
        mmVerticalMenus = !1,
        livIconsOptions = {},
        livIconsOptionsCache = [],
        mmDisableVisibleCheck = !1,
        mmDomChangesInterval = 200,
        mmMobileMenuTreeOffsetLeft = 25,
        mmInitBuddhaMegaMenuInterval = 200,
        mmInitBuddhaMegaMenuTimeout = 10,
        mmAtcPopupSuccess = "JUST ADDED TO YOUR CART",
        mmAtcPopupOutOfStock = "OUT OF STOCK",
        mmMenuOverflowAuto = !1,
        mmAddStyle = function(e, t) {
            const n = document.createElement("style");
            if (n.textContent = e, void 0 !== t) {
                n.id = t;
                var a = document.getElementById(t);
                a && a.parentNode.removeChild(a)
            }
            document.head.appendChild(n)
        },
        mmAddLink = function(e, t) {
            const n = document.createElement("link");
            if (n.href = e, n.type = "text/css", n.rel = "stylesheet", void 0 !== t) {
                n.id = t;
                var a = document.getElementById(t);
                a && a.parentNode.removeChild(a)
            }
            document.head.appendChild(n)
        },
        mmAddClasses = function(e, t) {
            try {
                if (t && "string" == typeof t)
                    for (var n = t.replace(/\s+/g, " ").split(" "), a = 0; a < n.length; a++) {
                        var m = n[a].trim();
                        "" != m && e.classList.add(m)
                    }
            } catch (e) {
                var m = new Error(e.message + " |" + t);
                mmErrorLog(m)
            }
        },
        mmForEach = function(e, t, n, a) {
            for (var m = e.querySelectorAll(t), o = 0; o < m.length; o++) n(m[o]);
            if (void 0 !== a) return m
        },
        mmForEachChild = function(e, t, n) {
            var a = e.children;
            if (a)
                for (var m = 0; m < a.length; m++) a[m].nodeName == t && n(a[m])
        },
        mmGetChildren = function(e, t, n) {
            var a, m, o = e.id;
            if (e.parentNode) {
                var i = e.id = o || "mmGC_TID_1234",
                    u = "#" + i + " > ";
                t = u + (t + "").replace(",", "," + u, "g"), a = e.parentNode
            } else a = e;
            return m = 1 == n ? a.querySelector(t) : a.querySelectorAll(t), !o && e.parentNode && e.removeAttribute("id"), m
        },
        mmNot = function(e, t, n) {
            for (var a = [], m = 0; m < e.length; m++) e[m].matches(t) || (void 0 === n || 0 == n || 1 == n && !e[m].querySelector(t)) && a.push(e[m]);
            return a
        },
        mmParents = function(e, t) {
            for (var n = [], a = e; a.parentNode != document;) void 0 !== t && a.parentNode.tagName != t || n.push(a.parentNode), a = a.parentNode;
            return n
        },
        mmIsVisible = function(e) {
            return !!e && (e.offsetHeight > 0 || e.offsetWidth > 0 || "contents" == e.style.display && e.children && e.children[0].offsetParent)
        },
        mmRemove = function(e) {
            for (var t = document.querySelectorAll(e), n = 0; n < t.length; n++) t[n].parentNode.removeChild(t[n])
        },
        mmHash = function(e) {
            var t, n, a = 0;
            if (0 === e.length) return a;
            for (t = 0; t < e.length; t++) n = e.charCodeAt(t), a = (a << 5) - a + n, a |= 0;
            return a < 0 && (a *= -1), a
        },
        mmSetFontStyle = function(e) {
            mmAddStyle(".horizontal-mega-menu .buddha-menu-item ul.mm-submenu, .horizontal-mega-menu .buddha-menu-item ul.mm-submenu li a, .horizontal-mega-menu .buddha-menu-item ul.mm-submenu li .mm-title, .buddha-menu-item ul.mm-submenu a, .vertical-mega-menu .buddha-menu-item ul.mm-submenu, .vertical-mega-menu .buddha-menu-item ul.mm-submenu li a, .horizontal-mega-menu .buddha-menu-item ul.mm-submenu.simple>li .mm-list-name>span, .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content, .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content span, .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content b, .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content textarea, .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content input {" + e + "}")
        },
        mmNumErrors = 0,
        mmErrorLog = function(e) {
            var t = !1,
                n = !1,
                a = !1;
            (-1 != document.head.innerHTML.indexOf("mm-init.js?") || document.body && -1 != document.body.innerHTML.indexOf("mm-init.js?")) && (t = !0);
            for (var m = 0; m < schemaDesignJSON.length; m++) "menu-select" == schemaDesignJSON[m].action && "none" != schemaDesignJSON[m].value && (n = schemaDesignJSON[m].value);
            if (-1 == navigator.userAgent.indexOf("Mediapartners-Google") && -1 == navigator.userAgent.indexOf("Yandex") || (a = !0), mmNumErrors++, t && n && !a && mmNumErrors <= 1) {
                var o = new XMLHttpRequest;
                o.open("POST", "https://notify.bugsnag.com/"), o.setRequestHeader("Content-Type", "application/json"), o.setRequestHeader("Bugsnag-Api-Key", "b1d0f3de79a0970e706491de768a5c2e"), o.setRequestHeader("Bugsnag-Payload-Version", "5"), o.onreadystatechange = function() {
                    4 === this.readyState && (console.log("Status:", this.status), console.log("Headers:", this.getAllResponseHeaders()), console.log("Body:", this.responseText))
                };
                var i = {
                    apiKey: "b1d0f3de79a0970e706491de768a5c2e",
                    payloadVersion: "5",
                    notifier: {
                        name: "Bugsnag Ruby",
                        version: "1.0.11",
                        url: "https://github.com/bugsnag/bugsnag-ruby",
                        dependencies: [{
                            name: "Bugsnag Android",
                            version: "2.1.10",
                            url: "https://github.com/bugsnag/bugsnag-android"
                        }]
                    },
                    events: [{
                        exceptions: [{
                            errorClass: "buddha-megamenu-V2.js",
                            message: e.message,
                            stacktrace: [{
                                file: window.location.hostname,
                                code: {
                                    0: window.location.href,
                                    1: e.stack
                                }
                            }]
                        }],
                        unhandled: !1,
                        device: {
                            browserName: navigator.userAgent
                        }
                    }]
                };
                throw o.send(JSON.stringify(i)), e
            }
        };
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(e) {
        var t = this;
        do {
            if (Element.prototype.matches.call(t, e)) return t;
            t = t.parentElement || t.parentNode
        } while (null !== t && 1 === t.nodeType);
        return null
    }), Array.from || (Array.from = function(e) {
        "use strict";
        return [].slice.call(e)
    });
    var loadBuddhaMegaMenu = function() {
            readyStateCheckInterval = setInterval(initBuddhaMegaMenu, mmInitBuddhaMegaMenuInterval), setTimeout(function() {
                clearInterval(readyStateCheckInterval)
            }, 35e3), mmAddStyle(generateMobileMenuColors("#017b86", !0), "buddhaInitialMobileMenuColors"), window.self !== window.top && ("loading" !== document.readyState ? initSchema() : window.addEventListener("load", initSchema), setTimeout(function() {
                initSchema()
            }, 5e3)), 0 != mmInitBuddhaMegaMenuTimeout && setTimeout(initBuddhaMegaMenu, mmInitBuddhaMegaMenuTimeout)
        },
        mmStaticMenuFn = function() {
            try {
                mmForEach(document, ".horizontal-mega-menu>.buddha-menu-item>.mm-submenu", function(e) {
                    if (parseInt(window.getComputedStyle(e).getPropertyValue("top")) > 0) {
                        var t = e.parentNode;
                        if (e.matches(".mm-submenu.simple,.mm-submenu.tabbed")) {
                            var n = !1;
                            if (0 == mmMenuOverflowAuto)
                                for (var a = mmParents(t.parentNode), m = 0; m < a.length; m++) {
                                    var o = window.getComputedStyle(a[m]).getPropertyValue("position");
                                    "fixed" != o && "sticky" != o || (n = !0)
                                } else n = !0;
                            var i = e.getBoundingClientRect(),
                                u = parseInt(i.top),
                                r = 2e3;
                            n ? r = window.innerHeight - u : document.documentElement.offsetHeight <= window.innerHeight + 100 && (r = document.documentElement.offsetHeight - 150), i.height >= r - 30 ? (e.style.maxHeight = r + "px", e.style.overflow = "scroll", e.style.overflowX = "hidden", e.style.clip = "unset", e.style.setProperty("box-shadow", "0 10px 20px rgba(0,0,0,.1)", "important")) : (e.style.maxHeight = "none", e.style.overflow = "hidden", e.style.removeProperty("clip"), e.style.removeProperty("box-shadow"))
                        }
                    }
                })
            } catch (e) {
                mmErrorLog(e)
            }
        },
        mmInitVarsWaitTime = 0,
        initBuddhaMegaMenu = function() {
            try {
                if ("undefined" == typeof mmWireSlices || "undefined" == typeof bestSellersHTML || "undefined" == typeof newestProductsHTML || "undefined" == typeof mmLivIcons || "undefined" == typeof linkLists || "undefined" == typeof mmNumMMI || "undefined" == typeof productImageAndPrice || "undefined" == typeof collectionImages || "undefined" == typeof mmSchemaTranslation) return mmInitVarsWaitTime++ >= 50 && (clearInterval(readyStateCheckInterval), mmErrorLog(new Error("init vars not defined" + (window.self !== window.top ? "preview" : "")))), !1;
                if (Object.keys(mmWireSlices).length != mmWireSlices[0] + 1 || 0 != mmLivIcons && (1 != mmLivIcons || 1 != mmLivIconsLoaded) || !(window.self !== window.top || window.self === window.top && jQueryBuddha.isReady)) return !1;
                newMenu = "";
                for (var e = 1; e <= mmWireSlices[0]; e++) newMenu += mmWireSlices[e].html;
                newMenu = newMenu.replace(new RegExp('<div id="bsWidget">', "g"), bestSellersHTML), newMenu = newMenu.replace(new RegExp('<div id="npWidget">', "g"), newestProductsHTML);
                var t = Object.keys(productImageAndPrice);
                for (e = 0; e < t.length; e++) {
                    var n = -1 != productImageAndPrice[t[e]][2].indexOf("mega-menu-sold_out") ? "mm-sold-out" : "";
                    newMenu = newMenu.replace(new RegExp('<div class="mega-menu-prices get-mega-menu-prices" data-id="' + t[e] + '"></div>', "g"), '<div class="mega-menu-prices ' + n + '">' + productImageAndPrice[t[e]][2] + "</div>")
                }
                if (void 0 !== mmSchemaTranslation.menuStrings && 1 == mmSchemaTranslation.enabled) {
                    var a = mmSchemaTranslation.menuStrings[mmShopLocale];
                    if (void 0 !== a) {
                        for (var m in a) {
                            var o = a[m].trim();
                            m = m.trim().replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), "" != o && (newMenu = newMenu.replace(new RegExp('"' + m + '"', "g"), '"' + o + '"'), newMenu = newMenu.replace(new RegExp(">" + m + "<", "g"), ">" + o + "<"), newMenu = newMenu.replace(new RegExp(">" + m + "&nbsp;<", "g"), ">" + o + "<"))
                        }
                        var i = window.location.hostname,
                            u = mmShopLocale.split("-")[0]; - 1 != i.indexOf(u + ".") || -1 != i.indexOf("." + u, i.length - u.length - 1) || "en" == u && -1 != i.indexOf(".co.uk") || (newMenu = newMenu.replace(new RegExp('"/"', "g"), '"/' + mmShopLocale + '"'), newMenu = newMenu.replace(new RegExp('"/collections', "g"), '"/' + mmShopLocale + "/collections"), newMenu = newMenu.replace(new RegExp('"/products', "g"), '"/' + mmShopLocale + "/products"), newMenu = newMenu.replace(new RegExp('"/pages', "g"), '"/' + mmShopLocale + "/pages"), newMenu = newMenu.replace(new RegExp('"/blogs', "g"), '"/' + mmShopLocale + "/blogs"), newMenu = newMenu.replace(new RegExp(buddhaMegaMenuShop + "/collections", "g"), buddhaMegaMenuShop + "/" + mmShopLocale + "/collections"), newMenu = newMenu.replace(new RegExp(buddhaMegaMenuShop + "/products", "g"), buddhaMegaMenuShop + "/" + mmShopLocale + "/products"))
                    }
                    if (void 0 !== (a = mmSchemaTranslation.additional[mmShopLocale])) {
                        void 0 !== a["Add to cart"] && "" !== a["Add to cart"] && (newMenu = newMenu.replace(new RegExp(">Add to cart<", "g"), ">" + a["Add to cart"] + "<")), void 0 !== a["Sold out"] && "" !== a["Sold out"] && (newMenu = newMenu.replace(new RegExp(">Sold out<", "g"), ">" + a["Sold out"] + "<")), void 0 !== a.Title && "" !== a.Title && (mmAtcPopupSuccess = a.Title), void 0 !== a["Out of Stock Title"] && "" !== a["Out of Stock Title"] && (mmAtcPopupOutOfStock = a["Out of Stock Title"]), void 0 !== a.NEW && "" !== a.NEW && (newMenu = newMenu.replace(new RegExp('"mm-label new">NEW<', "g"), '"mm-label new">' + a.NEW + "<")), void 0 !== a.HOT && "" !== a.HOT && (newMenu = newMenu.replace(new RegExp('"mm-label hot">HOT<', "g"), '"mm-label hot">' + a.HOT + "<")), void 0 !== a.SALE && "" !== a.SALE && (newMenu = newMenu.replace(new RegExp('"mm-label sale">SALE<', "g"), '"mm-label sale">' + a.SALE + "<")), void 0 !== a["Business Info"] && "" !== a["Business Info"] && (newMenu = newMenu.replace(new RegExp('<div class="mm-head">Business Info</div>', "g"), '<div class="mm-head">' + a["Business Info"] + "</div>")), void 0 !== a.Info && "" !== a.Info && (newMenu = newMenu.replace(new RegExp('<div class="mm-desc">.*?</div>', "g"), '<div class="mm-desc">' + a.Info + "</div>")), void 0 !== a.Address && "" !== a.Address && (newMenu = newMenu.replace(new RegExp('<div class="mm-address">.*?</div>', "g"), '<div class="mm-address"><a href="http://maps.google.com/?q=' + a.Address + '"target="_blank">' + a.Address + "</a></div>"));
                        var r = document.querySelector("#mmContactFormHTML");
                        void 0 !== a.Name && "" !== a.Name && mmForEach(r, ".contact-form .mm-name input", function(e) {
                            e.setAttribute("placeholder", a.Name)
                        }), void 0 !== a.Email && "" !== a.Email && mmForEach(r, ".contact-form .mm-email input", function(e) {
                            e.setAttribute("placeholder", a.Email)
                        }), void 0 !== a.Message && "" !== a.Message && mmForEach(r, ".contact-form .mm-message textarea", function(e) {
                            e.setAttribute("placeholder", a.Message)
                        }), void 0 !== a["Send Message"] && "" !== a["Send Message"] && mmForEach(r, ".contact-form .mm-contact-submit", function(e) {
                            e.innerHTML = a["Send Message"]
                        }), void 0 !== a["Message Sent Notification"] && "" !== a["Message Sent Notification"] && mmForEach(r, ".successForm.feedback", function(e) {
                            e.innerHTML = a["Message Sent Notification"]
                        })
                    }
                }
                clearInterval(readyStateCheckInterval), "undefined" != typeof InstantClick && InstantClick.on("change", function(e) {
                    e || null == document.querySelector(".horizontal-mega-menu,.vertical-mega-menu") && (ulPaths = [], storeUlCount = 0, storeNavCount = 0, preloadBuddhaMegaMenu())
                });
                var l = !1;
                if ((-1 != document.head.innerHTML.indexOf("mm-init.js?") || document.body && -1 != document.body.innerHTML.indexOf("mm-init.js?")) && (l = !0), l) {
                    var s = 0,
                        d = setInterval(function() {
                            s++, "undefined" != typeof mutationExceptions && (mutationExceptions[mutationExceptions.length] = ".buddha-menu-item", clearInterval(d)), s > 10 && clearInterval(d)
                        }, 1e3);
                    if ("undefined" != typeof mmCustomerFixesBeforeInit && -1 == mmCustomerFixesBeforeInit()) return void mmRemove("#mmHideOriginalMenuStyle");
                    "undefined" != typeof mmThemeFixesBeforeInit && 0 == disableThemeScript && mmThemeFixesBeforeInit(), null == document.querySelector(burgerIcon) && (burgerIcon = ".js-mobile-nav-toggle,.js-drawer-open-left,.js-drawer-open-button-left,#wsnavtoggle,.header__mobile-nav-toggle,#mobileNavBar .menu-toggle,.js-drawer-open-nav,.icon-menu,.js-mobile-menu-icon,.header__mobile__button,.toggle-menu,.slicknav_btn,.Header__Icon,.icon-nav,.site-header__navigation,.mobile-header-controls__menu,.header__icon--menu,.jas-push-menu-btn", null == document.querySelector(burgerIcon) && (burgerIcon = "*")), initSchema(), window.self !== window.top && (mmRemove("#admin_bar_iframe"), document.querySelector("html").style.paddingTop = "0px", setInterval(function() {
                        mmForEach(document, "*", function(e) {
                            var t = window.getComputedStyle(e),
                                n = t.getPropertyValue("top"),
                                a = t.getPropertyValue("position");
                            "40px" == n && "fixed" == a && (e.style.top = "0px")
                        })
                    }, 1e3));
                    var c, h = window.innerWidth;
                    window.addEventListener("resize", function() {
                        try {
                            h != window.innerWidth && (mmForEach(document, ".mm-hovering", function(e) {
                                e.classList.remove("mm-hovering")
                            }), clearTimeout(c), c = setTimeout(function() {
                                const e = document.createEvent("Event");
                                e.initEvent("mmWindowResize", !0, !0), document.dispatchEvent(e);
                                var t = !1,
                                    n = document.querySelector(".mega-hover");
                                n && (t = n.getAttribute("itemId"));
                                var a = !1;
                                g = document.querySelectorAll("ul").length, p = document.querySelectorAll("nav").length, g -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length, storeUlCount == g && storeNavCount == p || (storeUlCount = g, storeNavCount = p, a = !0);
                                for (var m = 0; m < ulPaths.length; m++) {
                                    var o = document.querySelector(ulPaths[m]);
                                    (!o || o && o.querySelectorAll(".buddha-menu-item").length != mmNumMMI) && (a = !0)
                                }
                                if (a) applyMegaMenu(), applyOnClick();
                                else
                                    for (var m = 0; m < ulPaths.length; m++) reinitMenus(ulPaths[m]);
                                t && designPanelOpened(t), panelOpened && null == document.querySelector(".buddha-menu-item.mega-hover") && designPanelOpened(), h = window.innerWidth
                            }, 300))
                        } catch (e) {
                            mmErrorLog(e)
                        }
                    }), disableOnScroll || setInterval(mmStaticMenuFn, 1e3);
                    var g = document.querySelectorAll("ul").length,
                        p = document.querySelectorAll("nav").length;
                    g -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length;
                    var b = 1;
                    storeUlCount == g && storeNavCount == p || (storeUlCount = g, storeNavCount = p, applyMegaMenu(), applyOnClick()), clearInterval(f);
                    var f = setInterval(function() {
                        try {
                            if (b++, b > loadMegaMenuTries && clearInterval(f), g = document.querySelectorAll("ul").length, p = document.querySelectorAll("nav").length, g -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length, storeUlCount != g || storeNavCount != p) {
                                if (storeUlCount = g, storeNavCount = p, void 0 !== customMenuUls) {
                                    for (var e = 0, t = customMenuUls.split(","), n = 0; n < t.length; n++) {
                                        var a = document.querySelector(t[n]);
                                        a && a.matches(".vertical-mega-menu,.horizontal-mega-menu") && e++
                                    }
                                    if (e == t.length) return void clearInterval(f)
                                }
                                applyMegaMenu(), applyOnClick()
                            }
                        } catch (e) {
                            mmErrorLog(e)
                        }
                    }, mmDomChangesInterval)
                } else mmForEach(document, ".buddha-disabled-menu", function(e) {
                    e.classList.remove("buddha-disabled-menu")
                }), mmRemove("#mmHideOriginalMenuStyle"), mmForEach(document, "link[href]", function(e) {
                    -1 !== e.getAttribute("href").indexOf("buddha-megamenu.css") && e.parentNode.removeChild(e)
                }), "undefined" != typeof hideOriginalMenuInterval && clearInterval(hideOriginalMenuInterval);
                var v;
                document.addEventListener("lazyloaded", function(e) {
                    try {
                        var t = e.target,
                            n = t.closest(".mm-submenu.simple");
                        if (n) {
                            var a = t.closest(".mm-image");
                            if (a) {
                                t.removeAttribute("style"), a.removeAttribute("style"), t.style.width = t.width + "px", t.style.height = t.height + "px", a.style.height = t.height + "px";
                                var m = a.nextElementSibling;
                                if (m) {
                                    var o = m.firstChild;
                                    o && o.classList.contains("mmHidden") && (o.classList.remove("mmHidden"), o.classList.add("mmShow"))
                                }
                                setTimeout(function() {
                                    try {
                                        var e = a.closest("li");
                                        e && (e.getAttribute("image-type") || e.setAttribute("image-type", "fit-high"), setImageContainerDimensions(e))
                                    } catch (e) {
                                        mmErrorLog(e)
                                    }
                                }, 20), clearTimeout(v), v = setTimeout(function() {
                                    var e = n.parentNode,
                                        t = e.closest(".mm-submenu.tabbed"),
                                        a = n.getAttribute("columns");
                                    t && (a = t.getAttribute("columns") - 1), e.classList.contains("mm-hovering") && slideDownTransition(n), setSubmenuImageAndHeightBoundries(e, a), t && e.matches(".tab-opened") && setTabbedSubmenuBoundries(jQueryBuddha(e))
                                }, 200)
                            } else t.setAttribute("style", "border-radius: 50%; overflow: hidden;"), t.offsetWidth < 25 && (t.style.display = "none")
                        }
                    } catch (e) {
                        mmErrorLog(e)
                    }
                })
            } catch (e) {
                mmErrorLog(e)
            }
        },
        mmEvtApplyOnClick = function(e) {
            var t = e.target;
            clicked || touched || (clicked = !0, setTimeout(function() {
                try {
                    var e = t.closest(".horizontal-mega-menu"),
                        n = t.closest(".vertical-mega-menu");
                    if (!(changingPage || null != t.closest(".buddha-menu-item") || null != e && (null == e || mmIsVisible(e.querySelector(".buddha-menu-item"))) || null != n && (null == n || mmIsVisible(n.querySelector(".buddha-menu-item"))) || void 0 !== t.classList && (void 0 === t.classList || t.classList.contains("stop-mega-menu-reinit")) || null != t.closest(".mm-contact-content"))) {
                        var a = !1,
                            m = document.querySelectorAll("ul").length,
                            o = document.querySelectorAll("nav").length;
                        m -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length, storeUlCount == m && storeNavCount == o || (storeUlCount = m, storeNavCount = o, a = !0);
                        for (var i = 0; i < ulPaths.length; i++) {
                            var u = document.querySelector(ulPaths[i]);
                            (!u || u && u.querySelectorAll(".buddha-menu-item").length != mmNumMMI) && (a = !0)
                        }
                        if (onClickOnlyReinit || 0 == a)
                            for (var i = 0; i < ulPaths.length; i++) reinitMenus(ulPaths[i]);
                        else applyMegaMenu();
                        if ("undefined" != typeof DoublyGlobalCurrency) {
                            var r = document.querySelector(".currency-switcher-btn.selected");
                            r ? DoublyGlobalCurrency.convertAll(r.getAttribute("doubly-currency")) : (r = document.querySelector("[name=doubly-currencies]")) && DoublyGlobalCurrency.convertAll(r.value)
                        }
                    }
                } catch (e) {
                    mmErrorLog(e)
                }
            }, mobileMenuMilliseconds)), setTimeout(function() {
                clicked = !1
            }, mobileMenuMilliseconds + 50)
        },
        applyOnClick = function() {
            disableOnClick || void 0 == selectedMenu || "none" == selectedMenu || (clicked = !1, mmForEach(document, burgerIcon, function(e) {
                e.removeEventListener("click", mmEvtApplyOnClick), e.addEventListener("click", mmEvtApplyOnClick)
            }))
        },
        initSchema = function() {
            if (0 == initializedSchema) {
                initializedSchema = !0, "string" == typeof schemaDesignJSON && (schemaDesignJSON = JSON.parse(schemaDesignJSON));
                for (var e = 0; e < schemaDesignJSON.length; e++) {
                    var t = schemaDesignJSON[e];
                    if ("design" == t.action && void 0 != t.setting)
                        if (-1 != t.setting.indexOf("main_menu_item_size_")) {
                            var n = t.setting.replace("main_menu_item_size_", "");
                            submenuSizes[n] = parseInt(t.value) + 25
                        } else if (-1 != t.setting.indexOf("main_menu_item_direction_")) {
                        var n = t.setting.replace("main_menu_item_direction_", "");
                        submenuDirections[n] = t.value
                    } else if (-1 != t.setting.indexOf("main_menu_item_columns_")) {
                        var n = t.setting.replace("main_menu_item_columns_", "");
                        submenuColumns[n] = t.value
                    }
                }
                if (recreateDesign(), action = "", window.self !== window.top) {
                    var a = parent;
                    void 0 === parent.postMessage && (a = top), a.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
                }
            }
        },
        iframeReady = function() {
            previewPanelLoaded = !0, document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
        },
        reloadPreview = function() {
            location.reload()
        },
        initCountdown = function(e) {
            var t = e.attr("countdown_start"),
                n = e.attr("countdown_end"),
                a = new Date;
            if (0 == e.find(".buddha-menu-item-countdown").length && void 0 != t && !isNaN(Date.parse(t)) && void 0 != n && !isNaN(Date.parse(n))) {
                var m = new Date(n),
                    o = (m.getTime() - a.getTime()) / 1e3,
                    i = a.getTime() >= new Date(t).getTime();
                if (o < 0 && (o = 0), 1 == i && o > 0) {
                    e.find(">a>i.mm-angle-down:last").length > 0 ? e.find(">a>i.mm-angle-down:last").before(' <i class="buddha-menu-item-countdown"> <div></div> </i>') : e.find(">a>.mm-label").length > 0 ? e.find(">a>.mm-label").before(' <i class="buddha-menu-item-countdown"> <div></div> </i>') : e.find(">a").append(' <i class="buddha-menu-item-countdown"> <div></div> </i>');
                    var u = "HourlyCounter";
                    e.find(".buddha-menu-item-countdown").addClass("HourlyCounter"), o > 356400 && (u = "DailyCounter", e.find(".buddha-menu-item-countdown").removeClass("HourlyCounter")), e.find(".buddha-menu-item-countdown>div").FlipClock(o, {
                        clockFace: u,
                        countdown: !0
                    })
                }
            }
        },
        generateMobileMenuColors = function(e, t) {
            var n = "",
                a = ".vertical-mega-menu>" + (1 == t ? "li" : ".buddha-menu-item") + ">.mm-submenu.height-transition",
                m = LightenDarkenColor(e, 20);
            if (getBrightness(e) < 220)
                for (var o = 1; o < 8; o++) n += a + "{background-color: " + e + " !important;} ", n += a + ">li{background-color: inherit !important;} ", n += a + ">li>a{background-color: inherit !important;} ", n += a + ">li>a>.toggle-menu-btn>.mm-cross{background-color: " + m + " !important;} ", a += ">li>.mm-submenu.height-transition", e = LightenDarkenColor(e, 20), m = LightenDarkenColor(m, 20);
            else n += a + "{background-color: " + e + " !important;} ", n += a + ">li{background-color: inherit !important;} ", n += a + ">li>a{background-color: inherit !important;} ", n += a + ">li>a>.toggle-menu-btn>.mm-cross{background-color: " + m + " !important;} ";
            return n
        },
        shadeColor = function(e, t) {
            var n = parseInt(e.slice(1), 16),
                a = t < 0 ? 0 : 255,
                m = t < 0 ? -1 * t : t,
                o = n >> 16,
                i = n >> 8 & 255,
                u = 255 & n;
            return "#" + (16777216 + 65536 * (Math.round((a - o) * m) + o) + 256 * (Math.round((a - i) * m) + i) + (Math.round((a - u) * m) + u)).toString(16).slice(1)
        },
        customPropSettingsStyles = function(e, t) {
            var n = "";
            switch (e) {
                case "countdown_background_color":
                case "vertical_countdown_background_color":
                    var a = ".horizontal-mega-menu";
                    "vertical_countdown_background_color" == e && (a = ".vertical-mega-menu");
                    var m = t;
                    t = shadeColor(t, -.5);
                    var o = shadeColor(t, -.3);
                    n += a + " .flip-clock-wrapper ul.play li.flip-clock-before .up .shadow, .flip-clock-wrapper ul.play li.flip-clock-active .up .shadow {background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100%) !important;background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, " + t + ")) !important;background: linear, top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100% !important;background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100%) !important;background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100%) !important;background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, " + t + " 100% !important;}", n += a + " .flip-clock-wrapper ul.play li.flip-clock-before .down .shadow, .flip-clock-wrapper ul.play li.flip-clock-active .down .shadow {background: -moz-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, " + t + "), color-stop(100%, rgba(0, 0, 0, 0.1))) !important;background: linear, top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100% !important;background: -o-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: -ms-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: linear, to bottom, " + t + " 0%, rgba(0, 0, 0, 0.1) 100% !important;}", n += a + " .buddha-menu-item-countdown .inn { text-shadow: 0 1px 2px " + o + " !important; } .buddha-menu-item .flip-clock-wrapper ul li a div.down:after {background-color: " + m + " !important}";
                    break;
                case "background_color":
                    break;
                case "background_image_text_color":
                    n += ".horizontal-mega-menu .buddha-menu-item ul.mm-submenu.simple.backgroundImage > li .mm-list-name > span {border-bottom: 1px solid " + t + " !important;}";
                    break;
                case "vertical_text_color":
                    n += ".vertical-mega-menu ul.mm-submenu.simple > li .mm-list-name { border-bottom: 1px solid " + t + " !important; }";
                    break;
                case "vertical_background_color":
                    mmRemove("#buddhaInitialMobileMenuColors"), n += generateMobileMenuColors(t, !1);
                    break;
                case "font_size":
                    n += ".horizontal-mega-menu .buddha-menu-item .mm-description {font-size: " + (parseInt(t) - 1) + "px !important;}";
                    break;
                case "vertical_font_size":
                    n += ".vertical-mega-menu .buddha-menu-item .mm-description {font-size: " + (parseInt(t) - 1) + "px !important;}";
                    break;
                case "addtocart_background_color":
                    "#ffffff" == t && (t = "#000000"), n += ".horizontal-mega-menu .mm-add-to-cart>div {border-color: " + t + " !important;}";
                    break;
                case "addtocart_enable":
                    n += 1 == t ? ".horizontal-mega-menu .mm-add-to-cart {display: block !important;}" : ".horizontal-mega-menu .mm-add-to-cart {display: none !important;}";
                    break;
                case "addtocart_background_hover_color":
                    "#ffffff" == t && (t = "#000000"), n += ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {border-color: " + t + " !important;}";
                    break;
                case "vertical_addtocart_enable":
                    n += 1 == t ? ".vertical-mega-menu .mm-add-to-cart {display: block !important;}" : ".vertical-mega-menu .mm-add-to-cart {display: none !important;}";
                    break;
                case "vertical_addtocart_text_color":
                    n += ".vertical-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {color: " + LightenDarkenColor(t, -20) + " !important;}";
                    break;
                case "vertical_addtocart_background_color":
                    n += ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div {border-color: " + t + " !important;}", n += ".vertical-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {border-color: " + LightenDarkenColor(t, -20) + " !important;background-color: " + LightenDarkenColor(t, -20) + " !important;}";
                    break;
                case "vertical_price_color":
                    var i = getBrightness(t),
                        u = i > 190 ? -40 : 40;
                    n += ".vertical-mega-menu .buddha-menu-item ul.mm-submenu.simple>li .mega-menu-prices span.mega-menu-compare_at_price span {color: " + LightenDarkenColor(t, u) + ";}";
                    break;
                case "contact_left_bg_color":
                    n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info,.horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info a {background: " + t + " !important;}";
                    break;
                case "contact_left_alt_color":
                    for (var r = !1, l = schemaDesignJSON.length - 1; l >= 0; l--) {
                        var s = schemaDesignJSON[l];
                        if ("design" == s.action && "contact_left_bg_color" == s.setting) {
                            "#ffffff" != s.value && s.value != t || (r = !0);
                            break
                        }
                    }
                    var i = getBrightness(t),
                        u = i > 190 ? -60 : 60;
                    r ? (n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: inherit !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: inherit !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img {visibility: hidden !important;}") : (n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: " + t + " !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: " + t + " !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover>i {color: " + LightenDarkenColor(t, parseInt(2 * u)) + " !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img>.mm-large {background: " + t + " !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img>.mm-small {background: " + LightenDarkenColor(t, u) + "f0 !important;}");
                    break;
                case "contact_left_text_color":
                    n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info,.horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info a{color: " + t + " !important;}";
                    break;
                case "contact_right_text_color":
                    n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact>.mm-form {color: " + t + " !important;}";
                    break;
                case "contact_right_bg_color":
                    var d = LightenDarkenColor(t, -40),
                        c = LightenDarkenColor(t, -100);
                    n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact {background: " + t + " !important;}", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact input, .horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact textarea { border-bottom: 1px solid " + d + " !important; }", n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact input:focus, .horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact textarea:focus {border-bottom: 1px solid " + c + " !important;}";
                    break;
                case "vertical_contact_left_alt_color":
                    var i = getBrightness(t),
                        u = i > 190 ? -120 : 120;
                    n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: " + t + " !important;}", n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: " + t + " !important;}", n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover>i {color: " + LightenDarkenColor(t, u) + " !important;}";
                    break;
                case "contact_right_btn_bg_color":
                    t = LightenDarkenColor(t, -20), n += ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button:hover{background: " + t + " !important;}";
                    break;
                case "vertical_contact_right_btn_bg_color":
                    t = LightenDarkenColor(t, -20), n += ".vertical-mega-menu .buddha-menu-item ul.mm-submenu li.mm-contact-column button:hover{background: " + t + " !important;}"
            }
            return n
        },
        applyMegaMenu = function(e) {
            try {
                if ("undefined" != typeof mutationExceptions && (mutationExceptions[mutationExceptions.length] = "ul"), "undefined" != typeof hideOriginalMenuInterval && clearInterval(hideOriginalMenuInterval), void 0 != e) {
                    var t = [];
                    selectedMenu = e;
                    for (var n = 0; n < schemaDesignJSON.length; n++) "menu-select" != schemaDesignJSON[n].action && t.push(schemaDesignJSON[n]);
                    schemaDesignJSON = t, changedMenu = !0
                } else
                    for (var n = 0; n < schemaDesignJSON.length; n++) "menu-select" == schemaDesignJSON[n].action && (selectedMenu = schemaDesignJSON[n].value);
                0 == mmApplyOnce && (mmForEach(document, ".vertical-mega-menu", function(e) {
                    e.classList.remove("vertical-mega-menu")
                }), mmForEach(document, ".horizontal-mega-menu", function(e) {
                    e.classList.remove("horizontal-mega-menu")
                }), mmForEach(document, ".buddha-disabled", function(e) {
                    e.classList.remove("buddha-disabled")
                }), mmForEach(document, ".buddha-menu-item,#themeScript", function(e) {
                    e.parentNode.removeChild(e)
                }));
                for (var a = [], m = Object.keys(linkLists), n = 0; n < m.length; n++)
                    if (selectedMenu == m[n]) {
                        a = linkLists[m[n]].items;
                        break
                    } if (window.self !== window.top && console.log(a), void 0 != selectedMenu && "none" != selectedMenu && (a.length > 0 || void 0 != customMenuUls)) {
                    var o = customMenuUls || "ul,nav";
                    mmForEach(document, o, function(e) {
                        tempMenuObject = {}, tempMenuObject.u = e, tempMenuObject.ul = jQueryBuddha(e), tempMenuObject.forceMenu = !1, tempMenuObject.skipCheck = !1, tempMenuObject.elementFits = 0;
                        var t = [];
                        if (1 == mmApplyOnce && (e.classList.contains("vertical-mega-menu") || e.classList.contains("horizontal-mega-menu"))) return !0;
                        if (("undefined" == typeof mmThemeFixesBefore || 0 != disableThemeScript || -1 != mmThemeFixesBefore.call(e)) && (tempMenuObject.skipCheck || mmForEachChild(e, "LI", function(e) {
                                var t = null,
                                    n = e.querySelector("a");
                                if (n && (t = n.getAttribute("href")), null == t || null != t && ("#" == t.substr(0, 1) || "" == t)) {
                                    var m = e.querySelector(document.documentMode ? "* + a" : "a:nth-child(2)");
                                    m && (t = m.getAttribute("href"), n = m)
                                }
                                if (null == t || null != t && ("#" == t.substr(0, 1) || "" == t)) {
                                    var m = e.querySelector("a>a");
                                    m && (t = m.getAttribute("href"), n = m)
                                }
                                if (null == t || null != t && ("#" == t.substr(0, 1) || "" == t))
                                    for (var m = e.querySelectorAll("a[href]"), o = 0; o < m.length; o++) {
                                        var i = m[o].getAttribute("href");
                                        if (void 0 != a[tempMenuObject.elementFits] && i == a[tempMenuObject.elementFits]) {
                                            t = i, n = m[o];
                                            break
                                        }
                                    }
                                void 0 != a[tempMenuObject.elementFits] && t == a[tempMenuObject.elementFits] ? (void 0 == tempMenuObject.liClasses && (tempMenuObject.liClasses = ""), tempMenuObject.liClasses = concatClasses(e.getAttribute("class"), tempMenuObject.liClasses), void 0 == tempMenuObject.aClasses && (tempMenuObject.aClasses = ""), n && (tempMenuObject.aClasses = concatClasses(n.getAttribute("class"), tempMenuObject.aClasses)), void 0 == tempMenuObject.liItems && (tempMenuObject.liItems = []), -1 == jQueryBuddha.inArray(e, tempMenuObject.liItems) && (tempMenuObject.liItems[tempMenuObject.liItems.length] = e), e.classList.add("buddha-transparent"), tempMenuObject.elementFits++) : tempMenuObject.elementFits > 0 && tempMenuObject.elementFits != a.length && (tempMenuObject.elementFits = 0, tempMenuObject.liItems = [], mmForEach(document, ".buddha-transparent", function(e) {
                                    e.classList.remove("buddha-transparent")
                                }), t == a[0] && (tempMenuObject.elementFits = 1, tempMenuObject.liItems[tempMenuObject.liItems.length] = e, e.classList.add("buddha-transparent")))
                            }), "undefined" == typeof mmCustomerFixesBefore || -1 != mmCustomerFixesBefore.call(e)))
                            if (tempMenuObject.elementFits > 0 && tempMenuObject.elementFits == a.length && null == tempMenuObject.u.closest(".buddha-disabled") || tempMenuObject.forceMenu) {
                                for (var n = getSpecificClasses(tempMenuObject.liClasses), m = getSpecificClasses(tempMenuObject.aClasses), o = 0; o < tempMenuObject.liItems.length; o++) {
                                    var i;
                                    void 0 !== tempMenuObject.liItems[o] && (i = void 0 !== tempMenuObject.liItems[o].get ? tempMenuObject.liItems[o].get(0) : tempMenuObject.liItems[o]) && void 0 !== i && (i.classList.remove("buddha-transparent"), i.classList.add("buddha-disabled"))
                                }
                                if (newMenu) {
                                    e.insertAdjacentHTML("afterbegin", newMenu);
                                    var u = mmForEach(e, ".buddha-menu-item>.mm-submenu", function(e) {
                                        e.setAttribute("style", "display: none !important;")
                                    }, !0);
                                    t = mmForEach(e, ".buddha-menu-item", function(e) {
                                        var t = e.getAttribute("itemId");
                                        t && (void 0 !== submenuSizes[t] && e.setAttribute("submenu-size", submenuSizes[t]), void 0 !== submenuDirections[t] && e.setAttribute("submenu-direction", submenuDirections[t]), void 0 !== submenuColumns[t] && e.setAttribute("submenu-columns", submenuColumns[t])), mmAddClasses(e, n.common), mmForEachChild(e, "A", function(e) {
                                            mmAddClasses(e, m.common)
                                        })
                                    }, !0), mmForEach(e, ".buddha-menu-item[countdown_start]", function(e) {
                                        initCountdown(jQueryBuddha(e))
                                    }), mmForEach(e, ".buddha-menu-item>a>.mm-label", function(e) {
                                        e.classList.add("mm-hidden")
                                    }), mmForEach(e, ".mm-sold-out", function(e) {
                                        var t = e.parentNode.querySelector(".mm-add-to-cart");
                                        t && t.style.setProperty("display", "none", "important")
                                    }), mmForEach(e, ".get-collection-image", function(e) {
                                        var t = e.getAttribute("data-id");
                                        if (void 0 != collectionImages[t] && -1 == collectionImages[t][0].indexOf("no-image") && null == e.getAttribute("customimage")) {
                                            var n = e.closest("li[submenu-columns]"),
                                                a = e.closest("li[image-type]");
                                            n && (n = n.getAttribute("submenu-columns")), a && (a = a.getAttribute("image-type")), n = n || 1, null != a && -1 != a.indexOf("crop") && n++;
                                            var m = [320, 640, 960, 1280, -1, -1],
                                                o = m[n - 1];
                                            collectionImages[t][0] = -1 != o ? collectionImages[t][0].replace("_240x.", "_" + o + "x.") : collectionImages[t][0].replace("_240x.", "."), e.setAttribute("data-src", collectionImages[t][0]), e.setAttribute("aspect-ratio", collectionImages[t][1])
                                        }
                                    }), mmForEach(e, ".get-product-image", function(e) {
                                        var t = e.getAttribute("data-id");
                                        if (void 0 != productImageAndPrice[t] && -1 == productImageAndPrice[t][0].indexOf("no-image") && null == e.getAttribute("customimage")) {
                                            var n = e.closest("li[submenu-columns]"),
                                                a = e.closest("li[image-type]");
                                            n && (n = n.getAttribute("submenu-columns")), a && (a = a.getAttribute("image-type")), n = n || 1, null != a && -1 != a.indexOf("crop") && n++;
                                            var m = [320, 640, 960, 1280, -1, -1],
                                                o = m[n - 1];
                                            productImageAndPrice[t][0] = -1 != o ? productImageAndPrice[t][0].replace("_240x.", "_" + o + "x.") : productImageAndPrice[t][0].replace("_240x.", "."), e.setAttribute("data-src", productImageAndPrice[t][0]), e.setAttribute("aspect-ratio", productImageAndPrice[t][1])
                                        }
                                        if (void 0 != productImageAndPrice[t]) {
                                            var i = e.closest("li");
                                            if (i) {
                                                var u = i.querySelector(".mm-add-to-cart>div");
                                                u && (u.setAttribute("varid", productImageAndPrice[t][3]), u.setAttribute("sellingplan", productImageAndPrice[t][4]))
                                            }
                                        }
                                    }), mmForEach(e, ".mm-image img", function(e) {
                                        var t = e.closest("li[image-type]");
                                        if (t || (t = e.closest("li")), t) {
                                            var n = e.getAttribute("aspect-ratio");
                                            null != n && 0 != n || (n = 30);
                                            var a = t.getAttribute("submenu-columns"),
                                                m = t.getAttribute("image-type");
                                            a = a || 1, null != m && -1 != m.indexOf("crop") && a++;
                                            var o = [320, 640, 960, 1280, -1, -1],
                                                i = o[a - 1],
                                                u = i / n;
                                            e.style.width = i + "px", e.style.height = u + "px";
                                            var r = e.closest(".mm-image");
                                            r && (r.style.height = u + "px");
                                            var l = t.querySelector(".mm-label");
                                            l && l.classList.add("mmHidden")
                                        }
                                    }), mmForEach(e, "img[data-src]", function(e) {
                                        e.classList.add("mmLazyload")
                                    });
                                    var r = document.querySelector("#mmContactFormHTML>li");
                                    r && mmForEach(e, "#contactFormWidget", function(e) {
                                        var t = e.parentElement;
                                        t.appendChild(r.cloneNode(!0)), t.removeChild(e)
                                    });
                                    var l = function() {
                                        document.querySelector("#mmContactFormHTML input").click()
                                    };
                                    if (mmForEach(e, ".mm-contact-column input,.mm-contact-column textarea", function(e) {
                                            e.removeEventListener("focus", l), e.removeEventListener("click", l), e.addEventListener("focus", l), e.addEventListener("click", l)
                                        }), mmForEach(e, ".mm-contact", function(e) {
                                            var t = e.closest(".buddha-menu-item");
                                            t && null == t.getAttribute("submenu-size") && (e.matches(".mm-no-business-info") ? t.setAttribute("submenu-size", 700) : t.setAttribute("submenu-size", 850))
                                        }), document.documentMode && (mmForEach(e, ".mm-product-list img", function(e) {
                                            var t = "url(" + e.getAttribute("data-src") + ")";
                                            e.parentNode.insertAdjacentHTML("beforeend", '<div style="height:50px;width:50px;background-size:cover;background-repeat:no-repeat;background-position:50% 50%;background-image:' + t + '"></div>'), e.style.display = "none"
                                        }), mmAddStyle(".buddha-menu-item .mm-image a {width:100% !important; height: 100% !important;}", "mmIE11Fix")), u)
                                        for (var o = 0; o < u.length; o++) u[o].removeAttribute("style")
                                } else console.log("Megamenu ERROR - wireframe missing.");
                                if (n.first || m.first || n.last || m.last) {
                                    var s = e.querySelectorAll(".buddha-menu-item");
                                    if (s.length) {
                                        mmAddClasses(s[0], n.first), mmAddClasses(s[s.length - 1], n.last);
                                        var d = s[0].querySelector("a");
                                        d && mmAddClasses(d, m.first);
                                        var d = s[s.length - 1].querySelector("a");
                                        d && mmAddClasses(d, m.last)
                                    }
                                }
                                if (n.active || m.active)
                                    for (var o = 0; o < t.length; o++) {
                                        var d = t[o].querySelector("a");
                                        d && d.getAttribute("data-href") == window.location.pathname && (mmAddClasses(d, m.active), mmAddClasses(t[o], n.active))
                                    }
                                if ("undefined" != typeof mmThemeFixesAfter && 0 == disableThemeScript && -1 == mmThemeFixesAfter.call(e)) return;
                                if ("undefined" != typeof mmCustomerFixesAfter && -1 == mmCustomerFixesAfter.call(e)) return;
                                void 0 !== burgerIcon && "*" != burgerIcon || mmForEach(document, 'input[type="search"],input[type="text"]', function(e) {
                                    e.classList.add("stop-mega-menu-reinit")
                                });
                                var c = document.querySelector(".dl-menu");
                                c && setTimeout(function() {
                                    document.addEventListener("toggleSubmenu", function() {
                                        setTimeout(function() {
                                            c.classList.add("dl-menuopen")
                                        }, 1)
                                    })
                                }, 100), "undefined" != typeof timber && void 0 !== timber.alignMenu && (timber.alignMenu = function() {});
                                var h = getUlPath(e),
                                    g = !1;
                                if (-1 == ulPaths.indexOf(h)) {
                                    for (var o = 0; o < ulPaths.length; o++) - 1 !== h.indexOf(ulPaths[o]) && (g = !0);
                                    g || (ulPaths[ulPaths.length] = h)
                                }
                                tempMenuObject = {}
                            } else mmForEach(document, ".buddha-transparent", function(e) {
                                e.classList.remove("buddha-transparent")
                            })
                    });
                    for (var n = 0; n < ulPaths.length; n++) livIconsOptionsCache[ulPaths[n]] = {
                        opt: "",
                        optMain: "",
                        optBg: ""
                    }, reinitMenus(ulPaths[n]);
                    addTouch()
                }
                if (mmForEach(document, ".buddha-disabled-menu", function(e) {
                        e.classList.remove("buddha-disabled-menu")
                    }), mmRemove("#mmHideOriginalMenuStyle"), window.self !== window.top) {
                    var i = parent;
                    void 0 === parent.postMessage && (i = top), i.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
                } else previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com");
                setTimeout(function() {
                    "undefined" != typeof mutationExceptions && mutationExceptions.pop()
                }, 100)
            } catch (e) {
                mmErrorLog(e)
            }
        },
        addUpdateLivIcons = function(e) {
            var t = document.querySelector(e);
            if (t) {
                var n = t.querySelectorAll(".mm-icon.dynamic");
                if (n) {
                    var a = t.querySelector(".buddha-menu-item>a");
                    if (a) {
                        var m, o, i, u = window.getComputedStyle(a).getPropertyValue("color");
                        t.matches(".horizontal-mega-menu") ? (m = {
                            strokeColor: livIconsOptions.horizontalColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.horizontalHover,
                            eventOn: "parent"
                        }, o = {
                            strokeColor: u,
                            eventOn: "parent"
                        }, i = {
                            strokeColor: livIconsOptions.horizontalBackgroundImageColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.horizontalHover,
                            eventOn: "parent"
                        }) : (m = {
                            strokeColor: livIconsOptions.verticalColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.verticalHover,
                            eventOn: "parent"
                        }, o = {
                            strokeColor: u,
                            eventOn: "parent"
                        }, i = m);
                        var r = !1,
                            l = JSON.stringify(m),
                            s = JSON.stringify(o),
                            d = JSON.stringify(i);
                        void 0 === livIconsOptionsCache[e] && (livIconsOptionsCache[e] = {
                            opt: "",
                            optMain: "",
                            optBg: ""
                        }), l != livIconsOptionsCache[e].opt && (livIconsOptionsCache[e].opt = l, r = !0), s != livIconsOptionsCache[e].optMain && (livIconsOptionsCache[e].optMain = s, r = !0), d != livIconsOptionsCache[e].optBg && (livIconsOptionsCache[e].optBg = d, r = !0);
                        for (var c = 0; c < n.length; c++) {
                            var h = m;
                            n[c].matches(".buddha-menu-item>a>.mm-icon") ? h = o : n[c].closest(".backgroundImage") && (h = i), n[c].matches(".livicon-evo-holder") ? r && jQueryBuddha(n[c]).updateLiviconEvo(h) : jQueryBuddha(n[c]).addLiviconEvo(h)
                        }
                    }
                }
            }
        },
        mmEvtEnterMmi = function(e) {
            var t = e.target;
            setSubmenuBoundries(jQueryBuddha(t)), setContactSubmenuBoundries(jQueryBuddha(t));
            var n = t.querySelector(".tab-opened");
            n && setTabbedSubmenuBoundries(jQueryBuddha(n))
        },
        mmEvtEnterTabbedLi = function(e) {
            var t = e.target;
            mmForEach(t.parentNode, ".tab-opened", function(e) {
                e.classList.remove("tab-opened")
            }), t.classList.add("tab-opened"), setTabbedSubmenuBoundries(jQueryBuddha(t))
        },
        reinitMenus = function(e, t) {
            mmForEach(document, e, function(n) {
                var a = mmGetChildren(n, ".buddha-menu-item"),
                    m = 0 != mmVerticalMenus && null != document.querySelector(mmVerticalMenus) && n.matches(mmVerticalMenus),
                    o = window.innerWidth;
                if (t = void 0 !== t ? t : "auto", 0 != mmDisableVisibleCheck || 0 != mmVerticalMenus && !m || !(o <= 800) || mmIsVisible(n) || "auto" != t) {
                    n.classList.remove("vertical-mega-menu"), n.classList.remove("horizontal-mega-menu");
                    var i = mmForEach(n, ".buddha-menu-item>.mm-submenu", function(e) {
                            e.style.setProperty("display", "none", "important")
                        }, !0),
                        u = 1;
                    if (null != document.querySelector(mmHorizontalMenus) && n.matches(mmHorizontalMenus)) t = "horizontal";
                    else if (m) t = "vertical";
                    else
                        for (var r, l = 0; l < a.length; l++) {
                            var s = a[l].offsetTop;
                            void 0 === r && (r = s), (s > r + 5 || s < r - 5) && u++, r = s
                        }
                    if ((u != a.length || 1 == u && o > verticalMenuMaxWidth) && 0 == forceMobile && "vertical" != t || "horizontal" == t) {
                        n.classList.add("horizontal-mega-menu"), mmForEach(n, ".submenu-opened", function(e) {
                            e.classList.remove("submenu-opened")
                        }), mmForEach(n, ".buddha-menu-item > a > .mm-label", function(e) {
                            e.classList.remove("mm-hidden")
                        }), mmForEach(n, ".buddha-menu-item[countdown_start] > a > .mm-label", function(e) {
                            null == e.parentNode.parentNode.querySelector(".mm-submenu") && e.style.setProperty("left", "0px", "important")
                        }), mmSetSmBoundriesOnReinit && setTimeout(function() {
                            for (var e = 0; e < a.length; e++) setSubmenuBoundries(jQueryBuddha(a[e])), setContactSubmenuBoundries(jQueryBuddha(a[e]))
                        }, 1), mmForEach(n, "ul.mm-submenu.tabbed>li", function(e) {
                            null == e.parentNode.querySelector(".tab-opened") ? (e.classList.add("tab-opened"), mmSetSmBoundriesOnReinit && setTabbedSubmenuBoundries(jQueryBuddha(e))) : e.classList.contains("tab-opened") && mmSetSmBoundriesOnReinit && setTabbedSubmenuBoundries(jQueryBuddha(e))
                        }), mmForEach(n, "ul.mm-submenu.tabbed>li", function(e) {
                            e.removeEventListener("mouseenter", mmEvtEnterTabbedLi), e.addEventListener("mouseenter", mmEvtEnterTabbedLi)
                        }), mmForEach(n, "ul.mm-submenu.tabbed>li:first-child", function(e) {
                            null == e.parentNode.querySelector(".tab-opened") && (e.classList.add("tab-opened"), setTabbedSubmenuBoundries(jQueryBuddha(e)))
                        }), mmForEach(n, ".contact-form", function(e) {
                            e.setAttribute("action", "/contact#contact_form1"), e.id = "contact_form1"
                        });
                        for (var l = 0; l < a.length; l++) a[l].removeEventListener("mouseenter", mmEvtEnterMmi), a[l].addEventListener("mouseenter", mmEvtEnterMmi)
                    } else {
                        n.classList.add("vertical-mega-menu"), mmForEach(n, ".mega-hover", function(e) {
                            e.classList.remove("mega-hover")
                        });
                        for (var l = 0; l < a.length; l++) a[l].classList.remove("disabled"), a[l].removeEventListener("mouseenter", mmEvtEnterMmi);
                        mmForEach(n, ".toggle-menu-btn", function(e) {
                            e.classList.add("fa-visible")
                        }), mmForEach(n, ".buddha-menu-item > a .mm-label", function(e) {
                            e.classList.remove("mm-hidden")
                        }), mmForEach(n, ".submenu-opened", function(e) {
                            e.classList.remove("submenu-opened"), e.classList.remove("height-transition"), e.removeAttribute("style")
                        }), mmForEach(n, ".toggle-menu-btn>.mm-cross", function(e) {
                            e.classList.remove("mm-cross")
                        });
                        var d = 0,
                            c = 0,
                            h = 0,
                            g = 0;
                        if (a.length) {
                            var p = window.getComputedStyle(a[0]),
                                b = window.getComputedStyle(a[0].querySelector("a"));
                            d = p.getPropertyValue("padding-left"), c = b.getPropertyValue("padding-left"), h = b.getPropertyValue("padding-top"), g = b.getPropertyValue("padding-bottom")
                        }
                        var f = parseInt(d) + parseInt(c);
                        f <= 15 && (f = 15);
                        var v = (parseInt(h) - parseInt(g)) / 2;
                        v = v < 0 ? "top: calc(50% - " + -1 * v + "px) !important;" : "top: calc(50% + " + v + "px) !important;";
                        for (var y = "", S = f + mmMobileMenuTreeOffsetLeft, w = ".vertical-mega-menu>.buddha-menu-item>.mm-submenu.tree", l = 1; l < 8; l++) y += w + ">li>a{margin-left: " + S + "px !important;} ", y += w + ">li{padding-bottom: 5px !important; padding-top: 5px !important; box-sizing: border-box !important;} ", S += 10, w += ">li>.mm-submenu.tree";
                        var M = "";
                        M += e + ".vertical-mega-menu>li ul.mm-submenu.tree>li>a>.toggle-menu-btn{right:" + f + "px !important;}", M += e + ".vertical-mega-menu>li ul.mm-submenu.tree>li>a { padding-right: " + (f + 28) + "px !important; }", M += e + ".vertical-mega-menu>li ul.mm-submenu.tree.mm-last-level>li>a{ padding-right: " + f + "px !important; }", M += e + ".vertical-mega-menu>li ul.mm-submenu.simple>li.mm-left-item{padding-left:" + f + "px !important;}", M += e + ".vertical-mega-menu>li ul.mm-submenu.simple>li.mm-right-item{padding-right:" + f + "px !important;}", M += e + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li{padding-left:" + f + "px !important;padding-right:" + f + "px !important;}", M += e + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu>li.mm-left-item {padding-left: 0px !important;}", M += e + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu>li.mm-right-item {padding-right: 0px !important;}", M += e + ".vertical-mega-menu>li ul.mm-submenu.mm-contact>li{padding-left:" + f + "px !important;padding-right:" + f + "px !important;}", M += e + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu.simple { padding-left:" + f + "px !important; padding-right:" + f + "px !important; margin-left:-" + f + "px !important; margin-right:-" + f + "px !important; }", M += e + ".vertical-mega-menu .buddha-menu-item > a > .toggle-menu-btn { right:" + f + "px !important;" + v + "}", M += y, mmAddStyle(M, "verticalMenuSpacing" + mmHash(e)), mmForEach(n, ".tab-opened", function(e) {
                            e.classList.remove("tab-opened")
                        }), forceMobile = !1
                    }
                    if (mmLivIcons && (void 0 !== jQueryBuddha.fn.addLiviconEvo ? addUpdateLivIcons(e) : (console.log("livicons retry"), setTimeout(function() {
                            void 0 !== jQueryBuddha.fn.addLiviconEvo ? addUpdateLivIcons(e) : console.log("liv err")
                        }, 300))), panelOpened ? (jQueryBuddha(".horizontal-mega-menu>.buddha-menu-item").unbind("mouseenter.addMegaHoverClass"), jQueryBuddha(".horizontal-mega-menu>.buddha-menu-item").bind("mouseenter.addMegaHoverClass", function() {
                            if (jQueryBuddha(".mega-hover").removeClass("mega-hover"), panelOpened && (jQueryBuddha(this).addClass("mega-hover"), window.self !== window.top)) {
                                var e = parent;
                                void 0 === parent.postMessage && (e = top);
                                var t = jQueryBuddha(".buddha-menu-item.mega-hover").attr("itemId");
                                e.postMessage(["updateMainMenuItemSelect", t], "*")
                            }
                        })) : jQueryBuddha(".mega-hover").removeClass("mega-hover"), i)
                        for (var l = 0; l < i.length; l++) i[l].style.removeProperty("display")
                }
            })
        },
        renderMobileMenuForce = function(e) {
            reinitMenus(e, "vertical")
        },
        concatClasses = function(e, t) {
            var n = [];
            return t && "" != t && (n = t.split(" ")), e && "" != e && (e = e.split(" "), jQueryBuddha.each(e, function(e, t) {
                -1 == jQueryBuddha.inArray(t, n) && (n[n.length] = t)
            })), n.join(" ")
        },
        getSpecificClasses = function(e) {
            var t = [];
            if (void 0 != e) {
                e = e.split(" ");
                var n = "";
                jQueryBuddha.each(e, function(e, a) {
                    -1 != a.indexOf("active") || -1 != a.indexOf("selected") || -1 != a.indexOf("current") ? t.active = a : -1 != a.indexOf("focus") ? t.focus = a : -1 != a.indexOf("first") ? t.first = a : -1 != a.indexOf("last") ? t.last = a : -1 == a.indexOf("buddha") && -1 == a.indexOf("dropdown") && -1 == a.indexOf("mm-subopen") && -1 == a.indexOf("hidden") && -1 == a.indexOf("hide") && (n += " " + a)
                }), t.common = n.trim()
            }
            return t
        },
        undoAction = function() {
            if (currentUndo = undo[undo.length - 1], "design" == currentUndo.action && (redo.unshift(currentUndo), schemaDesignJSON.splice(-1, 1), undo.splice(-1, 1), recreateDesign()), 0 == jQueryBuddha(".buddha-menu-item").length && jQueryBuddha("#themeScript").remove(), window.self !== window.top) {
                var e = parent;
                void 0 === parent.postMessage && (e = top), e.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            } else previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
        },
        redoAction = function() {
            if (tempMenuObject = {}, jQueryBuddha(".buddha-transparent").removeClass("buddha-transparent"), action = redo[0].action, "design" == action && (schemaDesignJSON.push(redo[0]), undo.push(redo[0]), recreateDesign()), redo.splice(0, 1), 0 == jQueryBuddha(".buddha-menu-item").length && jQueryBuddha("#themeScript").remove(), window.self !== window.top) {
                var e = parent;
                void 0 === parent.postMessage && (e = top), e.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            } else previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
        },
        clearAction = function() {
            if (jQueryBuddha.each(undo, function(e, t) {
                    undoAction()
                }), redo = [], 0 == jQueryBuddha(".buddha-menu-item").length && jQueryBuddha("#themeScript").remove(), window.self !== window.top) {
                var e = parent;
                void 0 === parent.postMessage && (e = top), e.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            } else previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
        },
        propSettings = {
            background_color: {
                element: ".horizontal-mega-menu ul.mm-submenu, .horizontal-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu li,.horizontal-mega-menu li.buddha-menu-item:hover ul.mm-submenu.simple li:hover, .horizontal-mega-menu li.buddha-menu-item.mega-hover ul.mm-submenu.simple li:hover",
                attribute: "background"
            },
            background_hover_color: {
                element: ".horizontal-mega-menu ul.mm-submenu.tree li:hover, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened",
                attribute: "background"
            },
            background_image_text_color: {
                element: ".horizontal-mega-menu ul.mm-submenu.backgroundImage a, .horizontal-mega-menu ul.mm-submenu.backgroundImage li.mm-contact-column span,.horizontal-mega-menu ul.mm-submenu.backgroundImage .mm-contact-content, .horizontal-mega-menu ul.mm-submenu.backgroundImage li",
                attribute: "color"
            },
            text_color: {
                element: '.horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li,.horizontal-mega-menu ul.mm-submenu li.mm-contact-column span,.horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu li a span,.horizontal-mega-menu ul.mm-submenu li.fa, .horizontal-mega-menu ul.mm-submenu.tree li:hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu li a[data-href="no-link"]:hover',
                attribute: "color"
            },
            link_hover_color: {
                element: ".horizontal-mega-menu ul.mm-submenu.tree li:hover>a, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a, .horizontal-mega-menu ul.mm-submenu li a:hover,.horizontal-mega-menu ul.mm-submenu li:hover>a, .horizontal-mega-menu ul.mm-submenu li a:hover i, .horizontal-mega-menu ul.mm-submenu li:hover>a>i, .horizontal-mega-menu ul.mm-submenu li a:hover>span, .horizontal-mega-menu ul.mm-submenu li:hover>a>span, .horizontal-mega-menu ul.mm-submenu.tree li.fa:hover:before, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover.fa:before, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened.fa:before, .horizontal-mega-menu ul.mm-submenu>li>.mega-menu-item-container>.mm-list-name>span[onclick]:hover",
                attribute: "color"
            },
            font_size: {
                element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu a,.horizontal-mega-menu ul.mm-submenu a>span,.horizontal-mega-menu ul.mm-submenu .money",
                attribute: "font-size"
            },
            price_color: {
                element: ".horizontal-mega-menu ul.mm-submenu.simple > li .mega-menu-prices span.mega-menu-price span",
                attribute: "color"
            },
            vertical_text_color: {
                element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu li.mm-contact-column span,.vertical-mega-menu ul.mm-submenu li a, .vertical-mega-menu ul.mm-submenu span, .vertical-mega-menu ul.mm-submenu>li>a>.toggle-menu-btn>.fa",
                attribute: "color"
            },
            vertical_link_hover_color: {
                element: ".vertical-mega-menu ul.mm-submenu>li:hover>a[onclick]:not([data-href='no-link']), .vertical-mega-menu ul.mm-submenu>li:hover>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu>li.mm-hovering>a[onclick]:not([data-href='no-link']),.vertical-mega-menu ul.mm-submenu>li.mm-hovering>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[onclick]:not([data-href='no-link']), .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu li a[onclick]:not([data-href='no-link']):hover, .vertical-mega-menu ul.mm-submenu.tree li:hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tree li.mm-hovering>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tabbed>li.mm-hovering>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tabbed>li:hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu>li>.mega-menu-item-container>.mm-list-name>span[onclick]:hover>span, .vertical-mega-menu ul.mm-submenu>li>.mega-menu-item-container .mm-list-info>a[onclick]:not([data-href='no-link']):hover>*",
                attribute: "color"
            },
            vertical_font_size: {
                element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu span, .vertical-mega-menu ul.mm-submenu.simple>li ul.mm-product-list>li .mm-list-info",
                attribute: "font-size"
            },
            vertical_price_color: {
                element: ".vertical-mega-menu ul.mm-submenu.simple > li .mega-menu-prices span.mega-menu-price span",
                attribute: "color"
            },
            font_family: {
                element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu a>.mm-title,.horizontal-mega-menu ul.mm-submenu a,.horizontal-mega-menu ul.mm-submenu li.mm-contact-column span",
                attribute: "font-family"
            },
            vertical_font_family: {
                element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu li a,.vertical-mega-menu ul.mm-submenu a,.vertical-mega-menu ul.mm-submenu a>.mm-title,.vertical-mega-menu ul.mm-submenu li.mm-contact-column span",
                attribute: "font-family"
            },
            contact_right_btn_bg_color: {
                element: ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button",
                attribute: "background"
            },
            contact_right_btn_text_color: {
                element: ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button",
                attribute: "color"
            },
            countdown_color: {
                element: ".horizontal-mega-menu .buddha-menu-item-countdown .inn",
                attribute: "color"
            },
            countdown_background_color: {
                element: ".horizontal-mega-menu .buddha-menu-item-countdown .inn,.horizontal-mega-menu .buddha-menu-item-countdown .up::after,.horizontal-mega-menu .buddha-menu-item-countdown .flip-clock-dot",
                attribute: "background"
            },
            addtocart_text_color: {
                element: ".horizontal-mega-menu .mm-add-to-cart>div",
                attribute: "color"
            },
            addtocart_text_hover_color: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover",
                attribute: "color"
            },
            addtocart_background_color: {
                element: ".horizontal-mega-menu .mm-add-to-cart>div",
                attribute: "background"
            },
            addtocart_background_hover_color: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover",
                attribute: "background"
            },
            vertical_contact_right_btn_bg_color: {
                element: ".vertical-mega-menu .buddha-menu-item ul.mm-submenu li.mm-contact-column button",
                attribute: "background"
            },
            vertical_contact_right_btn_text_color: {
                element: ".vertical-mega-menu ul.mm-submenu li.mm-contact-column button",
                attribute: "color"
            },
            vertical_countdown_color: {
                element: ".vertical-mega-menu .buddha-menu-item-countdown .inn",
                attribute: "color"
            },
            vertical_countdown_background_color: {
                element: ".vertical-mega-menu .buddha-menu-item-countdown .inn,.vertical-mega-menu .buddha-menu-item-countdown .up::after,.vertical-mega-menu .buddha-menu-item-countdown .flip-clock-dot",
                attribute: "background"
            },
            vertical_addtocart_text_color: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div",
                attribute: "color"
            },
            vertical_addtocart_background_color: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div",
                attribute: "background"
            },
            label_text_color_sale: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale",
                attribute: "color"
            },
            label_text_color_new: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.new",
                attribute: "color"
            },
            label_text_color_hot: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "color"
            },
            label_text_color_all: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale,.horizontal-mega-menu .buddha-menu-item .mm-label.new,.horizontal-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "color"
            },
            label_background_color_sale: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale",
                attribute: "background-color"
            },
            label_background_color_new: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.new",
                attribute: "background-color"
            },
            label_background_color_hot: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "background-color"
            },
            label_background_color_all: {
                element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale,.horizontal-mega-menu .buddha-menu-item .mm-label.new,.horizontal-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "background-color"
            },
            vertical_label_text_color_sale: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale",
                attribute: "color"
            },
            vertical_label_text_color_new: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.new",
                attribute: "color"
            },
            vertical_label_text_color_hot: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "color"
            },
            vertical_label_text_color_all: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale,.vertical-mega-menu .buddha-menu-item .mm-label.new,.vertical-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "color"
            },
            vertical_label_background_color_sale: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale",
                attribute: "background-color"
            },
            vertical_label_background_color_new: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.new",
                attribute: "background-color"
            },
            vertical_label_background_color_hot: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "background-color"
            },
            vertical_label_background_color_all: {
                element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale,.vertical-mega-menu .buddha-menu-item .mm-label.new,.vertical-mega-menu .buddha-menu-item .mm-label.hot",
                attribute: "background-color"
            }
        },
        liveDesign = function(e, t) {
            try {
                if (-1 !== e.indexOf("main_menu_item_size_")) {
                    var n = e.replace("main_menu_item_size_", ""),
                        a = jQueryBuddha('.horizontal-mega-menu>li[itemId="' + n + '"]');
                    "auto" == t ? (a.removeAttr("submenu-size"), delete submenuSizes[n], 0 == a.find(".mm-contact").length ? setSubmenuBoundries(a) : setContactSubmenuBoundries(a)) : (t = parseInt(t), a.attr({
                        "submenu-size": t
                    }), submenuSizes[n] = t, 0 == a.find(".mm-contact").length ? setSubmenuBoundries(a, t) : setContactSubmenuBoundries(a, t))
                } else if (-1 !== e.indexOf("main_menu_item_columns_")) {
                    var n = e.replace("main_menu_item_columns_", ""),
                        a = jQueryBuddha('.horizontal-mega-menu>li[itemId="' + n + '"]');
                    "auto" == t ? (a.removeAttr("submenu-columns"), delete submenuColumns[n], 0 == a.find(".mm-contact").length ? setSubmenuBoundries(a) : setContactSubmenuBoundries(a)) : (a.attr({
                        "submenu-columns": t
                    }), submenuColumns[n] = t, 0 == a.find(".mm-contact").length ? setSubmenuBoundries(a) : setContactSubmenuBoundries(a))
                } else {
                    var m = "";
                    void 0 !== propSettings[e] && (m += propSettings[e].element + "{" + propSettings[e].attribute + ":" + t + " !important; }"), m += customPropSettingsStyles(e, t), mmAddStyle(m, "tempStyle")
                }
            } catch (e) {
                mmErrorLog(e)
            }
        },
        reinitAfterDesignTimeout, updateDesign = function(e, t) {
            try {
                if (mmRemove("#tempStyle"), -1 === e.indexOf("main_menu_item_size_") && -1 === e.indexOf("main_menu_item_columns_") || "auto" != t) m = {}, m.action = "design", m.setting = e, m.value = t, defaultFontSelected = !1, "font_family" == m.setting && "Default" == m.value && (defaultFontSelected = !0), schemaDesignJSON.push(m), undo.push(m);
                else {
                    for (var n = [], a = schemaDesignJSON.length - 1; a >= 0; a--) {
                        var m = schemaDesignJSON[a];
                        "design" == m.action && m.setting == e || n.push(m)
                    }
                    schemaDesignJSON = n
                }
                if (recreateDesign(e), "font_size" != e && "font_family" != e && -1 === e.indexOf("main_menu_item_columns_") || jQueryBuddha(".horizontal-mega-menu>.buddha-menu-item.mega-hover>.mm-submenu").each(function() {
                        var t = jQueryBuddha(this);
                        if (parseInt(t.css("top")) > 0) {
                            var n = 10;
                            "font_family" != e && "font_size" != e || (n = 300), setTimeout(function() {
                                setSubmenuBoundries(t.parent()), setContactSubmenuBoundries(t.parent()), t.hasClass("tabbed") && setTabbedSubmenuBoundries(t.find(">li.tab-opened"))
                            }, n)
                        }
                    }), -1 !== e.indexOf("main_menu_item_columns_")) {
                    var o = e.replace("main_menu_item_columns_", "");
                    jQueryBuddha('.horizontal-mega-menu>li[itemId="' + o + '"]').find(">.mm-submenu.tabbed").length > 0 && (m.type = "tabbed")
                }
                if (clearTimeout(reinitAfterDesignTimeout), reinitAfterDesignTimeout = setTimeout(function() {}, 100), redo = [], window.self !== window.top) {
                    var i = parent;
                    void 0 === parent.postMessage && (i = top), i.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
                } else previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
            } catch (e) {
                mmErrorLog(e)
            }
        },
        recreateDesign = function(e) {
            var t = "",
                n = [];
            if (window.self !== window.top && void 0 !== e)
                for (var a = [], m = schemaDesignJSON.length - 1; m >= 0; m--) {
                    var o = schemaDesignJSON[m];
                    "design" == o.action && -1 == a.indexOf(o.setting) ? (a[a.length] = o.setting, n.push(o)) : "menu-select" == o.action && n.push(o)
                } else n = schemaDesignJSON;
            for (var m = 0; m < n.length; m++) {
                var o = n[m];
                if ("design" == o.action && void 0 != propSettings[o.setting]) "font_size" == o.setting ? fontSize = parseInt(o.value) : "font_family" == o.setting ? (mmRemove("#googleFontDesign"), "Default" != o.value && "Arial" != o.value && "Georgia" != o.value && "Tahoma" != o.value && "Trebuchet MS" != o.value && "Times New Roman" != o.value && "Verdana" != o.value && mmAddLink("//fonts.googleapis.com/css?family=" + o.value, "googleFontDesign")) : "vertical_font_family" == o.setting ? (mmRemove("#googleFontDesignVertical"), "Default" != o.value && "Arial" != o.value && "Georgia" != o.value && "Tahoma" != o.value && "Trebuchet MS" != o.value && "Times New Roman" != o.value && "Verdana" != o.value && mmAddLink("//fonts.googleapis.com/css?family=" + o.value, "googleFontDesignVertical")) : "text_color" == o.setting ? livIconsOptions.horizontalColor = o.value : "link_hover_color" == o.setting ? livIconsOptions.horizontalHover = o.value : "background_image_text_color" == o.setting ? livIconsOptions.horizontalBackgroundImageColor = o.value : "vertical_text_color" == o.setting ? livIconsOptions.verticalColor = o.value : "vertical_link_hover_color" == o.setting && (livIconsOptions.verticalHover = o.value), ("font_family" != o.setting || "font_family" == o.setting && !defaultFontSelected && "Default" != o.value) && (t += propSettings[o.setting].element + "{" + propSettings[o.setting].attribute + ": " + o.value + " !important; }");
                else if ("design" == o.action && -1 !== o.setting.indexOf("main_menu_item_direction_")) {
                    var i = o.setting.replace("main_menu_item_direction_", ""),
                        u = jQueryBuddha('.horizontal-mega-menu>li[itemId="' + i + '"]');
                    u.attr({
                        "submenu-direction": o.value
                    }), submenuDirections[i] = o.value, window.self !== window.top && (0 == u.find(".mm-contact").length ? setSubmenuBoundries(u, !1, o.value) : setContactSubmenuBoundries(u, !1, o.value))
                }
                "design" == o.action && (t += customPropSettingsStyles(o.setting, o.value))
            }
            if (mmAddStyle(t, "previewStyle"), mmLivIcons && window.self !== window.top && void 0 !== typeof e && "text_color,link_hover_color,vertical_text_color,vertical_link_hover_color,background_image_text_color,".indexOf(e + ",") >= 0)
                for (var m = 0; m < ulPaths.length; m++) {
                    var r = ulPaths[m];
                    void 0 === livIconsOptionsCache[r] && (livIconsOptionsCache[r] = {
                        opt: "",
                        optMain: "",
                        optBg: ""
                    }), addUpdateLivIcons(r)
                }
        },
        designPanelOpened = function(e) {
            var t;
            if (e && void 0 !== e) {
                if ("custom_addtocart" == e) {
                    var n = 0;
                    e = null, jQueryBuddha(".horizontal-mega-menu:visible .buddha-menu-item").each(function() {
                        var a = jQueryBuddha(this).find(".mm-add-to-cart").length;
                        a && void 0 !== a && a > n && (n = a, e = jQueryBuddha(this).attr("itemId"), t = jQueryBuddha(this).find(".mm-add-to-cart").first().closest(".mm-submenu.tabbed>li"))
                    })
                } else if ("custom_labels" == e) {
                    var n = 0;
                    e = null, jQueryBuddha(".horizontal-mega-menu:visible .buddha-menu-item").each(function() {
                        var a = jQueryBuddha(this).find(".mm-label").length;
                        a && void 0 !== a && a > n && (n = a, e = jQueryBuddha(this).attr("itemId"), t = jQueryBuddha(this).find(".mm-label").first().closest(".mm-submenu.tabbed>li"))
                    })
                } else if ("custom_contact" == e) e = jQueryBuddha(".horizontal-mega-menu:visible").find(".mm-contact").first().closest(".buddha-menu-item").attr("itemId");
                else if ("custom_fonts" == e) {
                    var a = jQueryBuddha(".horizontal-mega-menu:visible .mm-submenu.simple").first();
                    0 == a.length && (a = jQueryBuddha(".horizontal-mega-menu:visible .mm-submenu").first()), e = a.closest(".buddha-menu-item").attr("itemId")
                } else "price_color" == e && (e = jQueryBuddha(".horizontal-mega-menu:visible").find(".mega-menu-prices").first().closest(".buddha-menu-item").attr("itemId"));
                if (e && void 0 != typeof e && !jQueryBuddha('.horizontal-mega-menu:visible>.buddha-menu-item[itemId="' + e + '"]').is(".mega-hover") && (jQueryBuddha(".mega-hover").removeClass("mega-hover"), jQueryBuddha('.horizontal-mega-menu:visible>.buddha-menu-item[itemId="' + e + '"]').addClass("mega-hover"), window.self !== window.top)) {
                    var m = parent;
                    void 0 === parent.postMessage && (m = top), m.postMessage(["updateMainMenuItemSelect", e, "true"], "*")
                }
            } else panelOpened = !0, jQueryBuddha("ul.mm-submenu.tabbed").length > 0 ? jQueryBuddha(".horizontal-mega-menu:visible>.buddha-menu-item>ul.mm-submenu.tabbed").each(function() {
                return jQueryBuddha(this).closest(".buddha-menu-item").addClass("mega-hover"), !1
            }) : jQueryBuddha("ul.mm-submenu.simple").length > 0 ? jQueryBuddha(".horizontal-mega-menu:visible>.buddha-menu-item>ul.mm-submenu.simple").each(function() {
                return jQueryBuddha(this).closest(".buddha-menu-item").addClass("mega-hover"), !1
            }) : jQueryBuddha("ul.mm-submenu.contact").length > 0 ? jQueryBuddha(".horizontal-mega-menu:visible>.buddha-menu-item>ul.mm-submenu.contact").each(function() {
                return jQueryBuddha(this).closest(".buddha-menu-item").addClass("mega-hover"), !1
            }) : jQueryBuddha("ul.mm-submenu.tree").length > 0 && jQueryBuddha(".horizontal-mega-menu:visible>.buddha-menu-item>ul.mm-submenu.tree").each(function() {
                return jQueryBuddha(this).closest(".buddha-menu-item").addClass("mega-hover"), !1
            });
            if (setSubmenuBoundries(jQueryBuddha(".buddha-menu-item.mega-hover")), setContactSubmenuBoundries(jQueryBuddha(".buddha-menu-item.mega-hover")), t && void 0 != typeof t ? (t.parent().find(">.tab-opened").removeClass("tab-opened"), t.addClass("tab-opened"), setTabbedSubmenuBoundries(t)) : jQueryBuddha("ul.mm-submenu.tabbed").length > 0 && setTabbedSubmenuBoundries(jQueryBuddha(".buddha-menu-item.mega-hover>ul.mm-submenu.tabbed>li.tab-opened").length > 0 ? jQueryBuddha(".buddha-menu-item.mega-hover>ul.mm-submenu.tabbed>li.tab-opened") : jQueryBuddha(".buddha-menu-item.mega-hover>ul.mm-submenu.tabbed>li:first-child")), jQueryBuddha(".horizontal-mega-menu>.buddha-menu-item").unbind("mouseenter.addMegaHoverClass"), jQueryBuddha(".horizontal-mega-menu>.buddha-menu-item").bind("mouseenter.addMegaHoverClass", function() {
                    if (jQueryBuddha(".mega-hover").removeClass("mega-hover"), panelOpened && (jQueryBuddha(this).addClass("mega-hover"), window.self !== window.top)) {
                        var e = parent;
                        void 0 === parent.postMessage && (e = top);
                        var t = jQueryBuddha(".buddha-menu-item.mega-hover").attr("itemId");
                        e.postMessage(["updateMainMenuItemSelect", t], "*")
                    }
                }), !e && window.self !== window.top) {
                var m = parent;
                void 0 === parent.postMessage && (m = top);
                var o = jQueryBuddha(".buddha-menu-item.mega-hover").attr("itemId");
                m.postMessage(["updateMainMenuItemSelect", o], "*")
            }
        };
    window.addEventListener("message", function(e) {
        (~e.origin.indexOf("megamenu.buddhaapps.com") || ~e.origin.indexOf("https://megamenu-new") || ~e.origin.indexOf("https://megamenu-dev")) && ("object" == typeof e.data ? "applyMegaMenu" == e.data[0] ? (window[e.data[0]](e.data[1]), applyOnClick()) : -1 !== jQueryBuddha.inArray(e.data[0], ["undoAction", "redoAction", "clearAction", "initSaving", "designPanelClosed"]) ? window[e.data[0]]() : -1 !== jQueryBuddha.inArray(e.data[0], ["designPanelOpened"]) ? void 0 === e.data[1] ? window[e.data[0]]() : window[e.data[0]](e.data[1]) : -1 !== jQueryBuddha.inArray(e.data[0], ["liveDesign", "updateDesign"]) && window[e.data[0]](e.data[1], e.data[2]) : "string" == typeof e.data && "function" == typeof window[e.data] && window[e.data]())
    });
    var initSaving = function() {
            jQueryBuddha(".buddha-loader-wrapper").show(), jQueryBuddha(".buddha-loader-text").show(), saving = !0
        },
        slideUpTransition = function(e) {
            for (var t = parseInt(e.style.maxHeight), n = mmParents(e), a = 0; a < n.length; a++) n[a].matches("ul.mm-submenu") && (n[a].style.maxHeight = parseInt(n[a].style.maxHeight) - t + "px");
            var m = e.closest("li");
            m && mmForEach(m, ".mm-submenu", function(e) {
                e.style.maxHeight = 0, e.style.marginBottom = 0
            })
        },
        slideDownTransition = function(e) {
            var t = parseInt(e.scrollHeight) + 50;
            e.style.maxHeight = t + "px", e.closest("li").matches(":last-child") && (e.style.marginBottom = "-5px");
            for (var n = mmParents(e), a = 0; a < n.length; a++) n[a].matches(".mm-submenu") && (n[a].style.maxHeight = parseInt(n[a].style.maxHeight) + t + "px")
        },
        mmEvtToggleSubmenu = document.createEvent("Event");
    mmEvtToggleSubmenu.initEvent("toggleSubmenu", !0, !0);
    var toggleSubmenu = function(e) {
            try {
                if (!submenuToggled) {
                    submenuToggled = !0, setTimeout(function() {
                        submenuToggled = !1
                    }, 300);
                    var t = e.closest("li");
                    if (t) {
                        var n = e.closest(".vertical-mega-menu"),
                            a = t.querySelector("ul.mm-submenu");
                        if (a && n) {
                            var m;
                            if (a.classList.contains("submenu-opened")) m = n.clientHeight - parseInt(a.scrollHeight), slideUpTransition(a), mmForEach(t, ".toggle-menu-btn>span", function(e) {
                                e.classList.remove("mm-cross")
                            }), setTimeout(function() {
                                mmForEach(t, ".mm-hovering", function(e) {
                                    e.classList.remove("mm-hovering")
                                }), t.classList.remove("mm-hovering"), mmForEach(t, ".submenu-opened", function(e) {
                                    e.classList.remove("submenu-opened")
                                }), mmForEach(a, ".mmBounceInUp", function(e) {
                                    e.classList.remove("mmBounceInUp")
                                })
                            }, 600);
                            else {
                                t.classList.add("mm-hovering");
                                var o = e.querySelector("span");
                                o && o.classList.add("mm-cross"), a.classList.add("submenu-opened"), a.classList.add("height-transition");
                                var i = 0;
                                a.matches(".simple") && setSubmenuBoundries(jQueryBuddha(t)), m = n.clientHeight + parseInt(a.scrollHeight) + 50, slideDownTransition(a), setTimeout(function() {
                                    o.classList.contains("mm-cross") && slideDownTransition(a)
                                }, 600);
                                var u = a.getAttribute("columns");
                                u = null == u ? 1 : parseInt(u);
                                var r = 0,
                                    l = !0;
                                mmForEachChild(a, "LI", function(e) {
                                    var t = e.getAttribute("item-type"),
                                        n = e.getAttribute("submenu-columns");
                                    n = null == n ? 1 : parseInt(n), e.classList.remove("mm-left-item"), e.classList.remove("mm-right-item"), r += n >= u ? u : n, 2 == u && 1 == n && null != t && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(t) && (r += 1), null != e.closest(".mm-submenu.tree") && (r += 1);
                                    var a = e.nextElementSibling;
                                    if (a) {
                                        var m = a.getAttribute("item-type"),
                                            o = a.getAttribute("submenu-columns");
                                        o = null == o ? 1 : parseInt(o), 2 == u && 1 == o && null != m && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(m) && (o += 1), r + o > u && (r = u)
                                    }
                                    setTimeout(function() {
                                        e.classList.add("mmBounceInUp")
                                    }, i), null != e.closest(".mm-submenu.simple") && (r - u == 0 && e.classList.add("mm-right-item"), l && (e.classList.add("mm-left-item"), l = !1), r - u == 0 && (i += 150, r = 0, l = !0))
                                })
                            }
                            mmEvtToggleSubmenu.mmMobileHeight = m, mmEvtToggleSubmenu.mmSubmenu = a, document.dispatchEvent(mmEvtToggleSubmenu)
                        }
                    }
                }
            } catch (e) {
                mmErrorLog(e)
            }
            return "undefined" != typeof event && event.stopImmediatePropagation(), !1
        },
        mmGoToPage = function(e, t) {
            if (!changingPage && !submenuToggled && !mmTouchMoved) {
                var n = window.location.hostname.replace("www.", ""),
                    a = n.substr(0, n.indexOf(".")) + ".",
                    m = e.getAttribute("data-href");
                if (m && "no-link" != m)
                    if (-1 !== m.indexOf("http") && -1 === m.indexOf(a) && -1 === m.indexOf("myshopify.com")) {
                        changingPage = !0;
                        var o = window.open(m, "_blank");
                        o && o.focus(), setTimeout(function() {
                            changingPage = !1
                        }, 300)
                    } else changingPage = !0, window.location = m, setTimeout(function() {
                        changingPage = !1
                    }, 1e3);
                else t.stopPropagation()
            }
            return !1
        },
        getImgUrlLowRes = function(e, t) {
            if (null == e) return "";
            var n = {
                ".jpg": "_" + t + ".jpg",
                ".JPG": "_" + t + ".JPG",
                ".png": "_" + t + ".png",
                ".PNG": "_" + t + ".PNG"
            };
            for (key in n) {
                var a = e.lastIndexOf(key); - 1 != a && (e = e.substring(0, a) + n[key] + e.substring(a + key.length))
            }
            return e
        },
        mmAddToCartPopup = function(e, t) {
            switch (e) {
                case "hide":
                    document.querySelector(".mm-atc-popup").style.removeProperty("opacity"), document.querySelector(".mm-atc-popup").style.removeProperty("pointer-events"), setTimeout(function() {
                        document.querySelector(".mm-atc-popup").style.removeProperty("display")
                    }, 1e3);
                    break;
                case "show":
                    document.querySelector(".mm-atc-popup").style.setProperty("display", "flex", "important"), setTimeout(function() {
                        document.querySelector(".mm-atc-popup").style.setProperty("opacity", 1, "important"), document.querySelector(".mm-atc-popup").style.setProperty("pointer-events", "auto", "important")
                    }, 20);
                    break;
                case "setproduct":
                    var n = getImgUrlLowRes(t.items[0].image, "70x");
                    document.querySelector(".mm-atc-popup .mm-atc-head>span").innerHTML = mmAtcPopupSuccess, "" != n ? (document.querySelector(".mm-atc-popup .mm-atc-product-image").src = n, document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "block"), document.querySelector(".mm-atc-popup .mm-atc-product>div").style.removeProperty("padding")) : (document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "none"), document.querySelector(".mm-atc-popup .mm-atc-product>div").style.setProperty("padding", "0")), document.querySelector(".mm-atc-popup .mm-atc-product").setAttribute("href", t.items[0].url), document.querySelector(".mm-atc-popup .mm-atc-product-name").innerHTML = t.items[0].product_title, document.querySelector(".mm-atc-popup .mm-atc-product-variant").innerHTML = t.items[0].variant_title, "undefined" != typeof mmAddToCartPopupCallback && mmAddToCartPopupCallback();
                    break;
                case "error":
                    document.querySelector(".mm-atc-popup .mm-atc-head>span").innerHTML = mmAtcPopupOutOfStock, document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "none"), document.querySelector(".mm-atc-popup .mm-atc-product>div").style.setProperty("padding", "0"), document.querySelector(".mm-atc-popup .mm-atc-product-name").innerHTML = t.description, document.querySelector(".mm-atc-popup .mm-atc-product-variant").innerHTML = ""
            }
        },
        mmAddToCartTimeout, mmAddToCart = function(e) {
            var t = e.getAttribute("varid");
            if (t) {
                clearTimeout(mmAddToCartTimeout);
                var n = new XMLHttpRequest;
                n.open("POST", "/cart/add.js", !0), n.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), n.onreadystatechange = function() {
                    4 == n.readyState && (200 == n.status ? "undefined" != typeof HsCartDrawer ? HsCartDrawer.getSlideCart() : "undefined" != typeof mmAddToCartAfter ? mmAddToCartAfter() : (mmAddToCartPopup("setproduct", JSON.parse(n.responseText)), mmAddToCartPopup("show"), mmAddToCartTimeout = setTimeout(function() {
                        mmAddToCartPopup("hide")
                    }, 6e3)) : (mmAddToCartPopup("error", JSON.parse(n.responseText)), mmAddToCartPopup("show"), mmAddToCartTimeout = setTimeout(function() {
                        mmAddToCartPopup("hide")
                    }, 6e3)))
                };
                var a = {
                        items: [{
                            quantity: 1,
                            id: t
                        }]
                    },
                    m = e.getAttribute("sellingplan");
                "" != m && (a.items[0].selling_plan = m), n.send(JSON.stringify(a))
            }
        },
        setImageContainerDimensions = function(e) {
            var t = e.querySelector(".mm-image-container img");
            if (t) {
                var n = e.querySelector(".mm-image-container"),
                    a = e.querySelector(".mm-image"),
                    m = e.getAttribute("image-type");
                if (n && a && m) {
                    var o = null != e.closest(".vertical-mega-menu"),
                        i = t.naturalWidth,
                        u = t.naturalHeight;
                    if (0 !== i && 0 !== u) {
                        t.removeAttribute("style"), n.removeAttribute("style"), a.removeAttribute("style");
                        var r;
                        r = m.indexOf("-full") >= 0 ? n.getBoundingClientRect() : a.getBoundingClientRect();
                        var l = r.width,
                            s = r.height;
                        if (m.indexOf("fit-") >= 0) {
                            if (u > s) {
                                var d = u / s;
                                i /= d, u /= d
                            }
                            if (i > l) {
                                var d = i / l;
                                i /= d, u /= d
                            }
                        }
                        if (m.indexOf("crop-") >= 0) {
                            var c = !1,
                                h = l / s,
                                g = i / u;
                            if (g > 3 && o && (i / 2 > l && u / 2 >= 40 ? (u /= 2, i /= 2) : i / 1.5 > l && u / 1.5 >= 40 && (u /= 1.5, i /= 1.5)), i > l && (i = l), u > s && (u = s), g < .9 || g > 1.1 ? h > g ? "crop-wide-full" == m ? (e.setAttribute("image-type", "crop-high-full"), c = !0) : "crop-wide" == m && (e.setAttribute("image-type", "crop-high"), c = !0) : h < g && ("crop-high-full" == m ? (e.setAttribute("image-type", "crop-wide-full"), c = !0) : "crop-high" == m && (e.setAttribute("image-type", "crop-wide"), c = !0)) : "crop-wide-full" == m ? (e.setAttribute("image-type", "crop-high-full"), c = !0) : "crop-wide" == m && (e.setAttribute("image-type", "crop-high"), c = !0), c) {
                                i = t.naturalWidth, u = t.naturalHeight, g = i / u;
                                var r;
                                r = m.indexOf("-full") >= 0 ? n.getBoundingClientRect() : a.getBoundingClientRect(), l = r.width, s = r.height, g > 3 && o && (i / 2 > l && u / 2 >= 40 ? (u /= 2, i /= 2) : i / 1.5 > l && u / 1.5 >= 40 && (u /= 1.5, i /= 1.5)), i > l && (i = l), u > s && (u = s)
                            }
                        }
                        a.style.width = i + "px", a.style.height = u + "px";
                        var p = e.querySelector(".mm-image-container>.mm-label-wrap"),
                            b = e.querySelector(".mm-description");
                        p && (p.style.width = i + "px", p.style.height = u + "px"), b && (b.style.width = i + "px")
                    }
                }
            } else setImageContainerDimensionsVideo(e)
        },
        setImageContainerDimensionsVideo = function(e) {
            var t = e.querySelector(".mm-image-container .mm-video-player"),
                n = e.querySelector(".mm-image-container .mm-image");
            if (t && n) {
                var a = t.getBoundingClientRect(),
                    m = Math.ceil(a.width),
                    o = Math.ceil(a.height),
                    i = parseInt(n.offsetHeight);
                if (0 !== m && 0 !== o) {
                    t.removeAttribute("style"), n.removeAttribute("style"), o > i && (o = i), n.style.width = m + "px", n.style.height = o + "px";
                    var u = e.querySelector(".mm-image-container>.mm-label-wrap"),
                        r = e.querySelector(".mm-description");
                    u && (u.style.width = m + "px", u.style.height = o + "px"), r && (r.style.width = m + "px")
                }
            }
        },
        setSubmenuRowItemsHeight = function(e, t) {
            var n = 5,
                a = null != e.closest(".vertical-mega-menu");
            if (a) n = t;
            else if (e.parentNode.matches(".mm-submenu.tabbed[columns]")) n = e.parentNode.getAttribute("columns") - 1;
            else {
                var m = e.querySelector("ul.mm-submenu.simple[columns]");
                m && (n = m.getAttribute("columns"))
            }
            if (n > 1) {
                mmForEach(e, "ul.mm-submenu>li .mm-featured-title, ul.mm-submenu>li .mm-list-name, ul.mm-submenu>li .mega-menu-prices", function(e) {
                    e.removeAttribute("style")
                });
                var o = 0,
                    i = [],
                    u = [],
                    r = [],
                    l = [],
                    s = {},
                    d = {},
                    c = {},
                    h = 0,
                    g = e.querySelector(".mm-submenu");
                g && mmForEachChild(g, "LI", function(e) {
                    var m = e.getAttribute("item-type"),
                        g = e.getAttribute("image-type"),
                        p = e.getAttribute("submenu-columns");
                    if (p = null == p ? 1 : parseInt(p), a ? (o += p >= n ? n : p, 2 == t && 1 == o && null != m && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(m) && (o += 1)) : o += p, void 0 === s[p] && (s[p] = 0), void 0 === d[p] && (d[p] = 0), void 0 === c[p] && (c[p] = 0), m && g && -1 != ["featured-product", "featured-collection", "featured-article", "featured-custom", "video"].indexOf(m) && -1 == ["fit-high-full", "fit-wide-full", "crop-high-full", "crop-wide-full"].indexOf(g)) {
                        var b = e.querySelector(".mm-featured-title");
                        if (b) {
                            var f = b.offsetHeight;
                            d[p] < f && (d[p] = f), u.push([p, b])
                        }
                        var v = e.querySelector(".mm-image-container");
                        v && (itemImageHeight = v.offsetHeight, s[p] < itemImageHeight && (s[p] = itemImageHeight), i.push([p, v]));
                        var y = e.querySelector(".mega-menu-prices");
                        if (y) {
                            var S = y.offsetHeight;
                            c[p] < S && (c[p] = S), r.push([p, y])
                        }
                    } else {
                        var w = e.querySelector(".mm-list-name");
                        if (w) {
                            var M = w.offsetHeight;
                            M > h && (h = M), l.push(w)
                        }
                    }
                    var _ = e.nextElementSibling,
                        B = 0;
                    if (_ && (B = _.getAttribute("submenu-columns"), B = null == B ? 1 : parseInt(B), a)) {
                        var O = _.getAttribute("item-type");
                        (B >= 2 || 2 == t && 1 == B && null !== O && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(O)) && (B = 2)
                    }
                    if (o % n == 0 || null == _ || o + B > n) {
                        for (var x = 0; x < i.length; x++) i[x][1].style.height = s[i[x][0]] + "px";
                        for (var x = 0; x < u.length; x++) u[x][1].style.minHeight = d[u[x][0]] + "px";
                        for (var x = 0; x < r.length; x++) r[x][1].style.height = c[r[x][0]] + "px";
                        for (var x = 0; x < l.length; x++) l[x].style.height = h + "px";
                        o = 0, i = [], u = [], r = [], l = [], s = {}, d = {}, c = {}, h = 0
                    }
                })
            }
        },
        setSubmenuRowItemsZindex = function(e, t) {
            for (var n = !1, a = 0, m = !1, o = 0, i = 0, u = 1, r = 10, l = mmGetChildren(e, ".mm-submenu>li"), s = 0; s < l.length; s++) {
                var d = l[s].getAttribute("submenu-columns");
                d = d ? parseInt(d) : 1;
                var c = l[s].getAttribute("item-type");
                i += d, n || 1 != u || (n = null !== l[s].getAttribute("haslabel")), 1 == u && i <= t && (a = s), "featured-banner" != c && "featured-custom" != c || -1 == ["crop-high-full", "crop-wide-full"].indexOf(l[s].getAttribute("image-type")) || (m = !0), i > t && (u++, i = d, m = !1, o = s, r = 10 * u), l[s].style.zIndex = r, r--
            }
            if (n || !m)
                for (var s = 0; s < l.length; s++) n && s <= a && l[s].style.setProperty("padding-top", "15px", "important"), !m && s >= o && l[s].style.setProperty("margin-bottom", "10px", "important")
        },
        setSubmenuImageAndHeightBoundries = function(e, t) {
            setSubmenuRowItemsZindex(e, t);
            for (var n = mmGetChildren(e, ".mm-submenu>li"), a = 0; a < n.length; a++) {
                var m = n[a].getAttribute("image-type");
                null == m && null != n[a].querySelector(".mm-image-container img,.mm-image-container .mm-video-player") && (n[a].setAttribute("image-type", "fit-high"), m = "fit-high"), -1 != ["fit-high", "fit-wide", "crop-high", "crop-wide"].indexOf(m) && setImageContainerDimensions(n[a])
            }
            setSubmenuRowItemsHeight(e, t);
            for (var a = 0; a < n.length; a++) {
                var m = n[a].getAttribute("image-type"); - 1 != ["fit-high-full", "fit-wide-full", "crop-high-full", "crop-wide-full"].indexOf(m) && setImageContainerDimensions(n[a])
            }
        },
        setSubmenuBoundries = function(e, t, n) {
            try {
                if (0 == e.length) return;
                var a = e.get(0),
                    m = document.querySelector("body"),
                    o = null !== a.getAttribute("submenu-columns"),
                    i = 1e3,
                    u = 768,
                    r = 1e3,
                    l = 0;
                m && (r = m.offsetWidth, l = m.offsetLeft);
                var s = mmGetChildren(a, "ul.mm-submenu.simple", !0),
                    d = mmGetChildren(a, "ul.mm-submenu.tabbed", !0);
                if (s || d)
                    if (null != a.closest(".horizontal-mega-menu")) {
                        if (jQueryBuddha(e).parent().parents().each(function() {
                                var e = jQueryBuddha(this).offset().left + parseInt(jQueryBuddha(this).css("padding-left")) - l;
                                e < i && e > 0 && (i = e)
                            }), (1e3 == i || r <= 768) && (i = 0), t && void 0 !== t || void 0 === e.attr("submenu-size") || (t = e.attr("submenu-size")), n && void 0 !== n || void 0 === e.attr("submenu-direction") || (n = e.attr("submenu-direction")), customHeaderOffset) i = customHeaderOffset < r ? (r - customHeaderOffset) / 2 : 0;
                        else if (t) {
                            var u = 0;
                            void 0 !== e.attr("submenu-columns") && (5 == e.attr("submenu-columns") ? u = 1e3 : 4 == e.attr("submenu-columns") ? u = 800 : 3 == e.attr("submenu-columns") ? u = 600 : 2 == e.attr("submenu-columns") && (u = 400)), t < u && (t = u), i = t < r ? (r - t) / 2 : 0
                        }
                        if (jQueryBuddha(e).find(">ul.mm-submenu.simple").length > 0) var c = jQueryBuddha(e).find(">ul.mm-submenu.simple");
                        else var c = jQueryBuddha(e).find(">ul.mm-submenu.tabbed");
                        c.css({
                            width: "auto",
                            left: "auto",
                            right: "auto",
                            "max-width": "none",
                            "min-width": "auto"
                        }), 2 * i > r && (i = 0);
                        var h = r - 2 * i;
                        if (o) {
                            var g = e.attr("submenu-columns"),
                                p = c.attr("style");
                            p += "width:" + h + "px !important;", c.attr("style", p), "left" != n && "right" != n || (g > 4 && r < 768 ? n = "auto" : g > 3 && r < 512 ? n = "auto" : g > 2 && r < 384 && (n = "auto")), n && void 0 !== n && "auto" != n || (g > 2 && r < 462 ? g = 2 : g > 3 && r < 616 ? g = 3 : g > 4 && r < 768 && (g = 4)), c.attr("columns", g), e.find(">ul.simple>li").each(function() {
                                void 0 !== jQueryBuddha(this).attr("submenu-columns") && g < jQueryBuddha(this).attr("submenu-columns") && (void 0 == jQueryBuddha(this).attr("submenu-original-columns") && jQueryBuddha(this).attr("submenu-original-columns", jQueryBuddha(this).attr("submenu-columns")), jQueryBuddha(this).attr("submenu-columns", g))
                            }), e.find(">ul.simple>li").each(function() {
                                void 0 !== jQueryBuddha(this).attr("submenu-original-columns") && g >= jQueryBuddha(this).attr("submenu-columns") && jQueryBuddha(this).attr("submenu-original-columns") > jQueryBuddha(this).attr("submenu-columns") && (jQueryBuddha(this).attr("submenu-columns", g), jQueryBuddha(this).attr("submenu-original-columns") == g && jQueryBuddha(this).removeAttr("submenu-original-columns"))
                            }), e.find(">ul.tabbed>li>ul.simple>li").each(function() {
                                void 0 !== jQueryBuddha(this).attr("submenu-columns") && g - 1 < jQueryBuddha(this).attr("submenu-columns") && (void 0 == jQueryBuddha(this).attr("submenu-original-columns") && jQueryBuddha(this).attr("submenu-original-columns", jQueryBuddha(this).attr("submenu-columns")), jQueryBuddha(this).attr("submenu-columns", g - 1))
                            }), e.find(">ul.tabbed>li>ul.simple>li").each(function() {
                                void 0 !== jQueryBuddha(this).attr("submenu-original-columns") && g >= jQueryBuddha(this).attr("submenu-columns") && jQueryBuddha(this).attr("submenu-original-columns") > jQueryBuddha(this).attr("submenu-columns") && (jQueryBuddha(this).attr("submenu-columns", g - 1), jQueryBuddha(this).attr("submenu-original-columns") == g - 1 && jQueryBuddha(this).removeAttr("submenu-original-columns"))
                            })
                        } else {
                            var g = 5;
                            if (("left" == n || "right" == n) && r < 768 && (n = "auto"), h >= 1020) {
                                var p = c.attr("columns", 5).attr("style");
                                p += "width:" + h + "px !important; min-width:400px !important;", c.attr("style", p), g = 5
                            } else if (h >= 816) {
                                var p = c.attr("columns", 4).attr("style");
                                p += "width:" + h + "px !important; min-width:400px !important;", c.attr("style", p), g = 4
                            } else if (h >= 612) {
                                var p = c.attr("columns", 3).attr("style");
                                p += "width:" + h + "px !important; min-width:400px !important;", c.attr("style", p), g = 3
                            } else {
                                var p = c.attr("columns", 2).attr("style");
                                p += "width:" + h + "px !important; min-width:400px !important;", c.attr("style", p), g = 2
                            }
                            5 == g ? u = 1e3 : 4 == g ? u = 800 : 3 == g ? u = 600 : 2 == g && (u = 400)
                        }
                        var b = jQueryBuddha(e).offset().left - l + jQueryBuddha(e).outerWidth() / 2;
                        if (n && void 0 !== n && "auto" != n) {
                            if ("right" == n) {
                                var f = jQueryBuddha(e).offset().left + parseInt(jQueryBuddha(e).css("padding-left")),
                                    v = r - f + "px",
                                    y = 0;
                                parseInt(v) < parseInt(u) && (y = parseInt(u) - parseInt(v)), c.css({
                                    left: -y + "px",
                                    "max-width": v,
                                    "min-width": u
                                })
                            } else if ("left" == n) {
                                var S = r - (jQueryBuddha(e).offset().left + jQueryBuddha(e).outerWidth()),
                                    v = r - S + "px",
                                    w = 0;
                                parseInt(v) < parseInt(u) && (w = parseInt(u) - parseInt(v)), c.css({
                                    right: -w + "px",
                                    "max-width": v,
                                    "min-width": u
                                })
                            }
                        } else if (b < r / 2) {
                            var y = r - (r - (jQueryBuddha(e).offset().left - l)) - i;
                            y < 0 && (y = 0), c.css({
                                left: -y + "px"
                            })
                        } else {
                            var w = r - (jQueryBuddha(e).offset().left - l) - jQueryBuddha(e).outerWidth() - i;
                            w < 0 && (w = 0), c.css({
                                right: -w + "px"
                            })
                        }
                        jQueryBuddha(e).find(">ul.mm-submenu.tabbed").length > 0 && --g, jQueryBuddha(e).find(">ul.mm-submenu.tabbed").length > 0 && (jQueryBuddha(e).find("ul.mm-submenu.tabbed>li>a>i.mm-arrow").removeClass("mm-angle-left mm-angle-down mm-angle-right").addClass("mm-angle-right"), a = a.querySelector("ul.mm-submenu.tabbed>li.tab-opened")), a && setSubmenuImageAndHeightBoundries(a, g), disableOnScroll && setTimeout(mmStaticMenuFn, 100)
                    } else {
                        var M = a.closest(".vertical-mega-menu").offsetWidth;
                        M < r - 100 && (r = M), d && (d.style.left = "auto", d.style.right = "auto", d.style.setProperty("width", "auto", "important"), d.style.setProperty("height", "auto", "important"));
                        var _ = mmForEach(a, ".mm-submenu.simple", function(e) {
                                e.style.left = "auto", e.style.right = "auto", e.style.setProperty("width", "auto", "important"), mmForEachChild(e, "LI", function(e) {
                                    e.removeAttribute("style")
                                })
                            }, !0),
                            g = 2;
                        if (o) {
                            var B = a.closest(".buddha-menu-item");
                            B && (g = B.getAttribute("submenu-columns"), g = null == g ? 4 : parseInt(g), null == d && null == a.closest("ul.mm-submenu.tabbed") || (mmForEach(a, 'ul.mm-submenu.simple>li[submenu-columns="' + (g - 1) + '"]', function(e) {
                                e.setAttribute("submenu-columns", 5)
                            }), g++), g > 1 && r < 360 ? g = 1 : g > 2 && r < 540 ? g = 2 : g > 3 && r < 720 ? g = 3 : g > 4 && r < 900 && (g = 4));
                            for (var O = 0; O < _.length; O++) _[O].setAttribute("columns", g);
                            s && mmForEachChild(s, "LI", function(e) {
                                var t = e.getAttribute("submenu-columns"),
                                    n = e.getAttribute("submenu-original-columns");
                                null != t && (t = parseInt(t)), null != n && (n = parseInt(n)), null != t && g < t && (null == n && e.setAttribute("submenu-original-columns", t), e.setAttribute("submenu-columns", g)), null != t && null != n && g >= t && n > t && (e.setAttribute("submenu-columns", g), n == g && e.removeAttribute("submenu-original-columns"))
                            })
                        } else {
                            var x = a.offsetWidth,
                                k = 2;
                            x >= 540 ? g = 3 : x >= 360 ? g = 2 : (g = 1, k = 1);
                            for (var O = 0; O < _.length; O++) _[O].setAttribute("columns", g);
                            mmForEach(document, ".vertical-mega-menu ul.mm-submenu.mm-contact", function(e) {
                                e.setAttribute("columns", k)
                            })
                        }
                        s && setSubmenuImageAndHeightBoundries(a, g)
                    }
                else if (jQueryBuddha(e).find("ul.mm-submenu.tree").length > 0 && (jQueryBuddha(e).find("ul.mm-submenu").removeAttr("style"), 0 == jQueryBuddha(e).parents(".buddha-menu-item.mega-hover").length)) {
                    var b = jQueryBuddha(e).offset().left + jQueryBuddha(e).outerWidth() / 2;
                    b < r / 2 && ("auto" == e.attr("submenu-direction") || void 0 == e.attr("submenu-direction")) || "right" == e.attr("submenu-direction") ? (jQueryBuddha(e).find("ul.mm-submenu").removeClass("tree-open-left"), e.find("ul.mm-submenu.tree li>a>i.mm-arrow").removeClass("mm-angle-down mm-angle-right mm-angle-left"), jQueryBuddha(e).find("ul.mm-submenu.tree li").each(function() {
                        jQueryBuddha(this).find("ul.mm-submenu").length > 0 && jQueryBuddha(this).find(">a>i.mm-arrow").addClass("mm-angle-right")
                    })) : (jQueryBuddha(e).find("ul.mm-submenu").addClass("tree-open-left"), jQueryBuddha(e).find("ul.mm-submenu.tree li>a>i.mm-arrow").removeClass("mm-angle-down mm-angle-right mm-angle-left"), jQueryBuddha(e).find("ul.mm-submenu.tree li").each(function() {
                        jQueryBuddha(this).find("ul.mm-submenu").length > 0 && jQueryBuddha(this).find(">a>i.mm-arrow").addClass("mm-angle-left")
                    }))
                }
            } catch (e) {
                mmErrorLog(e)
            }
        },
        setTabbedSubmenuBoundries = function(e) {
            if (jQueryBuddha(e).closest(".horizontal-mega-menu").length > 0) {
                allowMainMenuRecalibration && setSubmenuBoundries(jQueryBuddha(e).closest(".buddha-menu-item"));
                var t = jQueryBuddha(e).parent().find(">li").index(jQueryBuddha(e));
                if (jQueryBuddha(e).find(">ul.mm-submenu").length > 0) {
                    jQueryBuddha(e).find(">ul.mm-submenu").removeAttr("style");
                    var n = jQueryBuddha(e).find(">ul.mm-submenu").outerHeight(),
                        a = 0;
                    if (jQueryBuddha(e).parent().find(">li").each(function() {
                            a += jQueryBuddha(this).outerHeight()
                        }), a >= n) {
                        var m = jQueryBuddha(e).parent().attr("style"),
                            o = "";
                        o += void 0 != m ? m + ";height:" + a + "px !important" : "height:" + a + "px !important", jQueryBuddha(e).parent().attr("style", o);
                        var m = jQueryBuddha(e).find(">ul.mm-submenu").attr("style"),
                            o = "";
                        o += void 0 != m ? m + ";height:" + a + "px !important" : "height:" + a + "px !important", jQueryBuddha(e).find(">ul.mm-submenu").attr("style", o)
                    } else {
                        var m = jQueryBuddha(e).parent().attr("style"),
                            o = "";
                        o += void 0 != m ? m + ";height:" + n + "px !important" : "height:" + n + "px !important", jQueryBuddha(e).parent().attr("style", o)
                    }
                } else jQueryBuddha(e).parent().css("height", "auto");
                var i = jQueryBuddha(e).parent().find(">li:nth-child(" + (t + 1) + ")").position();
                if (void 0 !== i) {
                    var u = i.top,
                        m = jQueryBuddha(e).find(">ul.mm-submenu").attr("style"),
                        o = "";
                    o += void 0 != m ? m + ";top:-" + u + "px !important" : "top:-" + u + "px !important", jQueryBuddha(e).find(">ul.mm-submenu").attr("style", o)
                }
            } else jQueryBuddha(e).closest(".vertical-mega-menu").find(".tab-opened").removeClass("tab-opened")
        },
        setContactSubmenuBoundries = function(e, t, n) {
            var a = jQueryBuddha("body").width(),
                m = 1e3;
            if (jQueryBuddha(e).find(">ul.mm-submenu.mm-contact").length > 0 && jQueryBuddha(e).closest(".horizontal-mega-menu").length > 0) {
                jQueryBuddha(e).parent().parents().each(function() {
                    var e = jQueryBuddha(this).offset().left + parseInt(jQueryBuddha(this).css("padding-left"));
                    e < m && e > 0 && (m = e)
                }), (1e3 == m || a <= 768) && (m = 0), t && void 0 !== t || void 0 === e.attr("submenu-size") || (t = e.attr("submenu-size")), n && void 0 !== n || void 0 === e.attr("submenu-direction") || (n = e.attr("submenu-direction")), customHeaderOffset ? m = customHeaderOffset < a ? (a - customHeaderOffset) / 2 : 0 : t && (m = t < a ? (a - t) / 2 : 0);
                var o = jQueryBuddha(e).find(">ul.mm-submenu.mm-contact");
                o.css({
                    width: "auto",
                    left: "auto",
                    right: "auto",
                    "max-width": "none",
                    "min-width": "auto"
                }), 2 * m > a && (m = 0);
                var i = a - 2 * m;
                ("left" == n || "right" == n) && a < 768 && (n = "auto");
                var u = jQueryBuddha(e).offset().left + jQueryBuddha(e).outerWidth() / 2;
                if (n && void 0 !== n && "auto" != n) {
                    if ("right" == n) {
                        var r = jQueryBuddha(e).offset().left + parseInt(jQueryBuddha(e).css("padding-left")),
                            l = a - r + "px",
                            s = 0;
                        parseInt(l) < parseInt(768) && (s = parseInt(768) - parseInt(l)), parseInt(i) > parseInt(l) && (i = l), o.css({
                            left: -s + "px",
                            width: i + "px",
                            "max-width": l,
                            "min-width": 768
                        })
                    } else if ("left" == n) {
                        var d = a - (jQueryBuddha(e).offset().left + jQueryBuddha(e).outerWidth()),
                            l = a - d + "px",
                            c = 0;
                        parseInt(l) < parseInt(768) && (c = parseInt(768) - parseInt(l)), parseInt(i) > parseInt(l) && (i = l), o.css({
                            right: -c + "px",
                            width: i + "px",
                            "max-width": l,
                            "min-width": 768
                        })
                    }
                } else if (u < a / 2) {
                    var s = a - (a - jQueryBuddha(e).offset().left) - m;
                    s < 0 && (s = 0), o.css({
                        left: -s + "px",
                        width: i + "px",
                        "min-width": "768px"
                    })
                } else {
                    var c = a - jQueryBuddha(e).offset().left - jQueryBuddha(e).outerWidth() - m;
                    c < 0 && (c = 0), o.css({
                        right: -c + "px",
                        width: i + "px",
                        "min-width": "768px"
                    })
                }
            } else jQueryBuddha(e).find("ul.mm-submenu.mm-contact").css({
                left: "auto",
                right: "auto",
                width: "auto",
                height: "auto",
                "min-width": "auto",
                "max-width": "none"
            }), jQueryBuddha(e).find(">ul.mm-submenu.mm-contact").width() <= 480 && jQueryBuddha(e).find(">ul.mm-submenu.mm-contact").addClass("one-column")
        },
        mmTouchMoved = !1,
        mmTouchOnce = !1,
        mmEvtTouchStart = function(e) {
            mmTouchMoved = !1
        },
        mmEvtTouchMove = function(e) {
            mmTouchMoved = !0
        },
        mmEvtTouchEnd = function(e) {
            var t = e.target;
            setTimeout(function() {
                mmTouchMoved = !1, mmTouchOnce = !1
            }, 300);
            try {
                if (0 == mmTouchOnce && 0 == mmTouchMoved)
                    if (mmTouchOnce = !0, null != t.closest(".vertical-mega-menu li")) {
                        var n = t.closest("li");
                        if (n) {
                            var a = n.querySelector("a>.toggle-menu-btn");
                            a || (a = n.querySelector("a>span>.toggle-menu-btn")), a ? n.classList.contains("mm-hovering") && null == t.closest(".toggle-menu-btn") || (e.preventDefault(), e.stopPropagation(), toggleSubmenu(a)) : null != t.closest(".buddha-menu-item") && (null != n.closest(".buddha-menu-item-countdown") ? e.preventDefault() : n.matches("li[item-type='link-list']") && null == n.querySelector(".mm-list-name span[onclick]") ? (e.preventDefault(), e.stopPropagation()) : null != n.closest(".mm-contact") || null == t.closest(".mm-add-to-cart") && setTimeout(function() {
                                if (!changingPage) {
                                    var e = n.querySelector("a");
                                    e && e.click()
                                }
                            }, 200))
                        }
                    } else if (null != t.closest(".horizontal-mega-menu li")) {
                    var n = t.closest("li");
                    if (n)
                        if (n.matches(".buddha-menu-item"))
                            if (n.classList.contains("mega-hover") || null == n.querySelector("ul.mm-submenu")) {
                                var m = n.querySelector("a");
                                m && mmGoToPage(m, e)
                            } else {
                                e.preventDefault(), e.stopPropagation(), mmForEach(document, ".mega-hover", function(e) {
                                    e.classList.remove("mega-hover")
                                }), n.classList.add("mega-hover"), setSubmenuBoundries(jQueryBuddha(n)), setContactSubmenuBoundries(jQueryBuddha(n));
                                var o = n.querySelector(".tab-opened");
                                o && setTabbedSubmenuBoundries(jQueryBuddha(o))
                            }
                    else if (n.parentNode.matches(".mm-submenu.tabbed")) {
                        if (null != n.querySelector("ul.mm-submenu"))
                            if (n.classList.contains("tab-opened")) {
                                var m = n.querySelector("a");
                                m && mmGoToPage(m, e)
                            } else e.preventDefault(), e.stopPropagation(), mmForEachChild(n.parentNode, "LI", function(e) {
                                e.classList.remove("tab-opened")
                            }), n.classList.add("tab-opened"), setTabbedSubmenuBoundries(jQueryBuddha(n)), setSubmenuBoundries(jQueryBuddha(n.parentNode.parentNode))
                    } else if (null != n.closest(".mm-submenu.tree") && null != n.querySelector("ul.mm-submenu"))
                        if (n.classList.contains("mega-hover")) {
                            var m = n.querySelector("a");
                            m && mmGoToPage(m, e)
                        } else {
                            e.preventDefault(), e.stopPropagation(), mmForEachChild(n.parentNode, "LI", function(e) {
                                e.classList.remove("mega-hover")
                            }), mmForEach(n, ".mega-hover", function(e) {
                                e.classList.remove("mega-hover")
                            }), n.classList.add("mega-hover");
                            for (var i = mmParents(n, "LI"), u = 0; u < i.length; u++) i[u].classList.add("mega-hover");
                            setSubmenuBoundries(jQueryBuddha(n))
                        }
                    else if (null != n.closest(".buddha-menu-item-countdown")) e.preventDefault();
                    else if (null != n.closest(".mm-contact")) e.preventDefault(), e.stopPropagation();
                    else if (null == t.closest(".mm-add-to-cart")) {
                        var r = t.closest(".mm-list-name");
                        if (r) {
                            var l = r.querySelector("span[onclick]");
                            l && mmGoToPage(l, e)
                        } else {
                            var m = n.querySelector("a");
                            m && mmGoToPage(m, e)
                        }
                    }
                }
            } catch (e) {
                mmErrorLog(e)
            }
        },
        mmEvtTouchEndGlobal = function(e) {
            var t = e.target;
            globalTouch && null == t.closest(".buddha-menu-item") && mmForEach(document, ".mega-hover", function(e) {
                e.classList.remove("mega-hover")
            })
        },
        addTouch = function() {
            document.removeEventListener("touchend", mmEvtTouchEndGlobal), document.addEventListener("touchend", mmEvtTouchEndGlobal);
            for (var e = 0; e < ulPaths.length; e++) {
                var t = document.querySelector(ulPaths[e]);
                t && (t.removeEventListener("touchstart", mmEvtTouchStart), t.addEventListener("touchstart", mmEvtTouchStart), t.removeEventListener("touchmove", mmEvtTouchMove), t.addEventListener("touchmove", mmEvtTouchMove), t.removeEventListener("touchend", mmEvtTouchEnd), t.addEventListener("touchend", mmEvtTouchEnd))
            }
        },
        getBrightness = function(e) {
            var t = parseInt(e.substring(1), 16);
            return .2126 * (t >> 16 & 255) + .7152 * (t >> 8 & 255) + .0722 * (t >> 0 & 255)
        },
        LightenDarkenColor = function(e, t) {
            var n = !1;
            "#" == e[0] && (e = e.slice(1), n = !0);
            var a = parseInt(e, 16),
                m = (a >> 16) + t;
            m > 255 ? m = 255 : m < 0 && (m = 0);
            var o = (a >> 8 & 255) + t;
            o > 255 ? o = 255 : o < 0 && (o = 0);
            var i = (255 & a) + t;
            return i > 255 ? i = 255 : i < 0 && (i = 0), (n ? "#" : "") + String("000000" + (i | o << 8 | m << 16).toString(16)).slice(-6)
        },
        getUlPath = function(e) {
            for (var t, n = !0; e;) {
                var a = e.tagName;
                if (!a) break;
                a = a.toLowerCase(), -1 == a.replace(/\s+/g, " ").indexOf(" ") && 0 != /^[A-Za-z][A-Za-z0-9-]*$/.test(a) || (a = "*");
                var m = "";
                ignoreClass = !1, "body" != a && "html" != a && ("string" == typeof e.id && "" != e.id && /[a-zA-Z]/.test(e.id.charAt(0)) ? m = "#" + e.id : e.classList.length > 0 && !n && !ignoreClass && "" != e.classList[0] && /[a-zA-Z]/.test(e.classList[0].charAt(0)) && (m = "." + e.classList[0]));
                for (var o = 0, i = !1, u = e; null != (u = u.previousElementSibling);) u.tagName && u.tagName.toLowerCase() == a && (i = !0), o++;
                for (var u = e; null != (u = u.nextElementSibling);)
                    if (u.tagName && u.tagName.toLowerCase() == a) {
                        i = !0;
                        break
                    }! document.documentMode && i && (-1 !== ["li", "ul", "header"].indexOf(a) || "div" == a && "" == m) && (a += ":nth-child(" + (o + 1) + ")"), n = !1, t = a + m + (t ? ">" + t : ""), e = e.parentNode
            }
            return t
        },
        preloadBuddhaMegaMenu = function() {
            "undefined" != typeof loadFlipClockBuddha && loadFlipClockBuddha(jQueryBuddha), "undefined" != typeof loadLivIconsBuddha ? (loadLivIconsBuddha(jQueryBuddha), mmLivIconsLoaded = !0) : setTimeout(function() {
                "undefined" != typeof loadLivIconsBuddha && loadLivIconsBuddha(jQueryBuddha), mmLivIconsLoaded = !0
            }, 300), void 0 !== loadBuddhaMegaMenu ? loadBuddhaMegaMenu() : setTimeout(function() {
                loadBuddhaMegaMenu()
            }, 1e3)
        },
        loadJqueryBuddha = function() {
            var xhr = new XMLHttpRequest;
            xhr.onreadystatechange = function() {
                var done = void 0 !== XMLHttpRequest.DONE ? XMLHttpRequest.DONE : 4;
                if (xhr.readyState == done) {
                    var data = xhr.responseText;
                    jQueryBuddha = data.replace(/jQuery/g, "jQueryBuddha"), eval(jQueryBuddha), "undefined" != typeof jQuery && void 0 !== jQuery.noConflict && ($ = jQuery.noConflict()), preloadBuddhaMegaMenu()
                }
            }, xhr.open("GET", mmjQueryFile, !0), xhr.send(null)
        },
        BuddhaMegaMenuMain = function() {
            if ("undefined" == typeof jQuery || "undefined" != typeof jQuery && (null == jQuery || null != jQuery && (void 0 === jQuery.fn || void 0 !== jQuery.fn && void 0 === jQuery.fn.jquery))) loadJqueryBuddha();
            else {
                var e = jQuery.fn.jquery.split(".");
                1 == parseInt(e[0]) && parseInt(e[1]) >= 7 || parseInt(e[0]) > 1 ? (jQueryBuddha = jQuery, preloadBuddhaMegaMenu()) : loadJqueryBuddha()
            }
        };
    if (window.self === window.top) BuddhaMegaMenuMain();
    else if ("loading" !== document.readyState) BuddhaMegaMenuMain();
    else {
        var mmLoaded = !1;
        document.addEventListener("DOMContentLoaded", function() {
            0 == mmLoaded && (mmLoaded = !0, BuddhaMegaMenuMain())
        }), setTimeout(function() {
            document.removeEventListener("DOMContentLoaded", BuddhaMegaMenuMain), 0 == mmLoaded && (mmLoaded = !0, BuddhaMegaMenuMain())
        }, 15e3)
    }
}